import * as Enumerable from "linq";
import { formatDistanceToNow, format, addMinutes, addHours, getWeek, getMonth, getYear, endOfMonth, startOfWeek, endOfWeek, endOfDay, endOfQuarter, startOfQuarter, getDay, addMonths, startOfMonth, addWeeks, startOfDay, addDays, addYears, differenceInDays } from "date-fns";
import * as Constants from "projects/core-lib/src/lib/helpers/constants";

declare const AppConfig: IAppConfig;
import { IAppConfig } from "projects/core-lib/src/lib/config/AppConfig";

import * as m from "projects/core-lib/src/lib/models/ngCoreModels";
import * as m5 from "projects/core-lib/src/lib/models/ngModels5";
import * as m5core from "projects/core-lib/src/lib/models/ngModelsCore5";


export class Helper {


  public static getSortIconName(propertyName: string, currentSort: string, isNumeric: boolean = false, isDate: boolean = false): string {

    if (!propertyName) {
      return "";
    }

    currentSort = currentSort || "";

    let icon = "sort";

    if (currentSort.startsWith(propertyName)) {
      icon = "sort-alpha-asc";
      if (isNumeric) {
        icon = "sort-numeric-asc";
      } else if (isDate) {
        icon = "sort-asc";
      }
    }

    if (currentSort.startsWith("-" + propertyName)) {
      icon = "sort-alpha-desc";
      if (isNumeric) {
        icon = "sort-numeric-desc";
      } else if (isDate) {
        icon = "sort-desc";
      }
    }

    return icon;

  }


  ///**
  //* List of scripts being loaded.  Script names are inserted here before they are loaded.
  //*/
  //protected static loadingScripts: string[] = [];

  ///**
  //* List of scripts that have been loaded.  Script names are inserted here after loading.
  //*/
  //protected static loadedScripts: string[] = [];

  ///**
  //* Gets list of scripts that have been loaded.
  //*/
  //public static LoadedScriptList(): string[] {
  //  return Helper.loadedScripts;
  //}

  ///**
  // * Check to see if script is loaded.
  // */
  //public static IsScriptLoaded(script: string): boolean {
  //  if (!script) {
  //    return true;
  //  }
  //  return (Helper.loadedScripts.indexOf(script) > -1);
  //}

  ///**
  // * Check to see if script is loaded.
  // */
  //public static AreScriptsLoaded(scripts: string[]): boolean {
  //  if (!scripts || scripts.length === 0) {
  //    return true;
  //  }
  //  for (var script of scripts) {
  //    if (!Helper.IsScriptLoaded(script)) {
  //      return false;
  //    }
  //  }
  //  return true;
  //}


  ///**
  // * Load scripts specified in the input string array.  This can be used in routes for lazy loading of controllers.
  // * @param scripts
  // * @returns {}
  // */
  //public static LoadScripts(scripts: string[]): any {

  //  if (!scripts || scripts.length === 0) {
  //    return false;
  //  }

  //  // This method didn't work as well due to the condition noted in the comments on the method below it.
  //  //var deferred = $q.defer();
  //  //// Since the promise resolution will be taking place outside the context of AngularJS (e.g. inside the $scriptjs context)
  //  //// AngularJS has to be explicitly told when the promise has been resolved (so to speak).  This is achieved by resolving
  //  //// the promise inside of the $apply method of the $rootScope.
  //  //$script(scripts, function () {
  //  //    // all dependencies have now been loaded by so resolve the promise
  //  //    $rootScope.$apply(function () {
  //  //        deferred.resolve();
  //  //    });
  //  //});
  //  //return deferred.promise;

  //  // async script loading is non-blocking causing the view to sometimes request the controller or component prior to the script being loaded.
  //  // This triggers an error to be logged so instead forced the function not to return until all scripts successfully loaded.
  //  // This is kind of hackish but makes sure the loads are successful prior to completing the resolve.
  //  // It also allows for loading of multiple scripts.
  //  $.ajaxSetup({ async: false, cache: true });
  //  var numLoaded: number = 0;
  //  for (var i: number = 0; i < scripts.length; i++) {
  //    if (!scripts[i] || scripts[i] === undefined) {
  //      // Nothing to load
  //      numLoaded++;
  //      if (numLoaded === scripts.length) {
  //        return true; //only return after all scripts are loaded, this is blocking, and will fail if all scripts aren't loaded.
  //      }
  //    } else {
  //      // Loading the same script multiple times is wasteful and ends up with duplicate component registrations, etc.
  //      if (Helper.loadingScripts.indexOf(scripts[i]) > -1) {
  //        //console.error("Already loading: " + scripts[i]);
  //        numLoaded++;
  //        if (numLoaded === scripts.length) {
  //          return true; //only return after all scripts are loaded, this is blocking, and will fail if all scripts aren't loaded.
  //        }
  //      } else {
  //        // Push into our loading list before we load so we don't load twice in different threads
  //        Helper.loadingScripts.push(scripts[i]);
  //        // Load the script
  //        $.getScript(scripts[i]).done(function (script, textStatus) {
  //          Helper.loadedScripts.push(scripts[i]);
  //          //console.error("Loaded: " + scripts[i]);
  //          numLoaded++;
  //          if (numLoaded === scripts.length) {
  //            return true; //only return after all scripts are loaded, this is blocking, and will fail if all scripts aren't loaded.
  //          }
  //        })
  //          .fail(function (jqxhr, settings, exception) {
  //            console.error(exception);
  //          });
  //        //if (scripts[i].startsWith("http")) {
  //        //    console.error("sleeping...");
  //        //    Helper.Sleep(20000);
  //        //}
  //      }
  //    }
  //  }

  //  return (numLoaded === scripts.length);

  //}


  /* function to save JSON to file from browser
  * adapted from http://bgrins.github.io/devtools-snippets/#console-save
  * @param {Object} data -- json object to save
  * @param {String} file -- file name to save to
  * @example saveJSON(myJsonObject, "saved_data.json");
  * @see https://stackoverflow.com/a/41553494
  */
  public static saveJSON(data: any, filename: string) {

    if (!data) {
      console.error('No data');
      return;
    }

    if (!filename) {
      filename = 'console.json';
    }

    if (typeof data === "object") {
      data = JSON.stringify(data, undefined, 4);
    }

    let blob = new Blob([data], { type: 'text/json' });
    let e = document.createEvent('MouseEvents');
    let a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    // Wrap in any to avoid error TS2339: Build:Property 'downloadurl' does not exist on type 'DOMStringMap'
    (<any>a.dataset).downloadurl = ['text/json', a.download, a.href].join(':');
    // TODO initMouseEvent() is a deprecated Web Standard and should not be used anymore. Instead, use the new MouseEvent() interface.
    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  }


  /**
   * Horrible way to let an async method have a chance to finish it's work.
   * @param milliseconds
   */
  public static sleep(milliseconds: number): void {
    var currentTime = new Date().getTime();
    while (currentTime + milliseconds >= new Date().getTime()) {
    }
  }

  public static elapsedTime(start: Date, end: Date, interval: "ms" | "seconds" | "minutes"): number {
    // valueOf() "Returns the stored time value in milliseconds since midnight, January 1, 1970 UTC."
    const ms = (end.valueOf() - start.valueOf()); // ms
    if (interval === "seconds") {
      return Math.round(ms / 1000);
    } else if (interval === "minutes") {
      return Math.round((ms / 1000) / 60);
    }
    return ms;
  }

  public static formatDateTime(datetime: Date | string, formatPattern: string) {
    if (datetime) {
      const d = new Date(datetime);
      if (Helper.equals(formatPattern, "fromnow", true) ||
        Helper.equals(formatPattern, "ago", true) ||
        Helper.equals(formatPattern, "relative", true)) {
        return formatDistanceToNow(d, { addSuffix: true });
      } else if (Helper.equals(formatPattern, "iso", true)) {
        return format(d, Constants.DateFormat.FnsIsoDateTime);
      } else if (formatPattern) {
        if (Helper.startsWith(formatPattern, "datetime", true)) {
          formatPattern = formatPattern.replace("datetime", "MMM d, yyyy, h:mm:ss aa");
        } else if (Helper.startsWith(formatPattern, "date", true)) {
          formatPattern = formatPattern.replace("date", "MMM d, yyyy");
        }
        try {
          let result = format(d, formatPattern);
          if (Helper.contains(result, "ago", true)) {
            result = result.replace("ago", formatDistanceToNow(d, { addSuffix: true }));
          }
          return result;
        } catch (Error) {
          return format(d, "MMM d, yyyy");
        }
      } else {
        return format(d, "MMM d, yyyy");
      }
    }
    return "";
  }


  public static getDateFromString(value: string | Date, timeZone: string = ""): Date {
    if (Helper.isString(value)) {
      if (!timeZone) {
        // No time zone then parse as-is
        return new Date(value);
      }
      if (Helper.equals(timeZone, "UTC", true)) {
        if (Helper.endsWith(value as string, "Z", true) || Helper.endsWith(value as string, "00:00", true)) {
          return new Date(value);
        } else {
          return new Date(`${value}Z`);
        }
      }
    } else {
      return value as Date;
    }
  }


  /**
  This method returns an ISO date time string in UTC time which we manually offset by a specified amount of hours taken from the user
  time zone setting. Since we want user time zone settings and not local browser time we use the utcOffset parameter applied against
  current UTC time and return this as an ISO formatted date time string instead of a date object because JSON stringification will
  convert date objects to UTC and we don't want that because server side we're expecting the user time zone setting to be correct.
  @param {number} utcOffset The user's UTC offset as a number of hours (e.g. 5, -4, -8.5, 0, etc.).
  */
  public static getCurrentDateTimeIsoStringInUserTimeZone(utcOffset: number) {
    //addMinutes function removes timezone offset from user local browser time, converting to UTC time
    //addHours manually changes the UTC date by a given number of hours
    //The Z at the end of the format string signals that the date is in UTC time, not the local browser time
    return format(addHours(addMinutes(new Date(), new Date().getTimezoneOffset()), utcOffset), "yyyy-MM-dd'T'HH:mm:ss'Z'");
  }

  /**
 * IMPORTANT: currentDateTime is set to the current time by default and is only an argument
 * so we can unit test this method. Otherwise, the unit tests will start to fail as the
 * currentDateTime will constantly be changing. This argument should not be used in production.
 * Returns a dateRangeSetting such as: "THIS WEEK", "THIS MONTH", "TODAY" which represents
 * the date range that was passed in. These values match values of the m5core.PickListSelectionViewModel[].
 * @param {Date} rangeStart
 * @param {Date} rangeEnd
 * @param {Date} currentDateTime
 * @returns
 *
 */
  public static getDateRangeSetting(rangeStart: Date, rangeEnd: Date, currentDateTime: Date = new Date()): string {

    let dateRange: string = "CUSTOM";
    let startDate: Date = null;
    let endDate: Date = null;

    if (!rangeStart || !rangeEnd) {
      return;
    }

    //Make sure we are actually assigning the older date as the start date, in case the parameters
    //were accidentally passed in incorrectly.
    if (rangeStart.getTime() < rangeEnd.getTime()) {
      startDate = rangeStart;
      endDate = rangeEnd;
    } else {
      startDate = rangeEnd;
      endDate = rangeStart;
    }

    //Number from 1-31 that represents the day of the month.
    let startDateDayOfMonth = startDate.getDate();
    let endDateDayOfMonth = endDate.getDate();

    //Number from 1-52 that represents the week of the year
    let startWeek = getWeek(startDate);
    let endWeek = getWeek(endDate);
    let currentWeek = getWeek(currentDateTime);

    //Number from 1-12 that represents the month
    let startMonth = getMonth(startDate) + 1;
    let endMonth = getMonth(endDate) + 1;
    let currentMonth = getMonth(currentDateTime) + 1;

    //Number that represents the year
    let startYear = getYear(startDate);
    let endYear = getYear(endDate);
    let currentYear = getYear(currentDateTime);

    //Number that represents a duration of days from a specified date
    let startDaysFromCurrent = differenceInDays(currentDateTime, startDate);
    let endDaysFromCurrent = differenceInDays(currentDateTime, endDate);

    let startDay = getDay(startDate); //of week
    let endDay = getDay(endDate);

    //The next 2 lines could be written in one line by doing ('month').format('DD')
    //but it was a hassle to mock in the unit test so I made it two lines.
    let endOfMonthDateTime = endOfMonth(endDate);
    let endOfMonthString = format(endOfMonthDateTime, 'dd');
    let endOfMonthNumber: number = parseInt(endOfMonthString);

    if (startDaysFromCurrent == 0 && endDaysFromCurrent == 0) {
      return dateRange = "TODAY";
    } else if (startDaysFromCurrent == 1 && endDaysFromCurrent == 1) {
      return dateRange = "YESTERDAY";
    } else if (startDaysFromCurrent == 2 && endDaysFromCurrent == 2) {
      return dateRange = "2 DAYS AGO";
    } else if (startDaysFromCurrent == 3 && endDaysFromCurrent == 3) {
      return dateRange = "3 DAYS AGO";
    } else if (startDaysFromCurrent == 2 && endDaysFromCurrent == 0) {
      return dateRange = "LAST 2 DAYS";
    } else if (startDaysFromCurrent == 3 && endDaysFromCurrent == 0) {
      return dateRange = "LAST 3 DAYS";
    } else if (startDaysFromCurrent == 7 && endDaysFromCurrent == 0) {
      return dateRange = "LAST 7 DAYS";
    }

    if (startYear == currentYear && endYear == currentYear) {
      if (startWeek == currentWeek && endWeek == currentWeek && startDay == 0 && endDay == 6) {
        return dateRange = "THIS WEEK";
      } else if (startWeek == currentWeek - 1 && endWeek == currentWeek - 1 && startDay == 0 && endDay == 6) {
        return dateRange = "LAST WEEK";
      } else if (startMonth == currentMonth && endMonth == currentMonth &&
        startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "THIS MONTH";
      } else if (startMonth == currentMonth - 1 && endMonth == currentMonth - 1 &&
        startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "LAST MONTH";
      }
    }

    //Handles cases where startDate is last year and endDate is this year but are still within the
    //realm of 'this week', 'last week', and 'last month' based on the current date.
    //Case of 12/27/20 to 1/2/21 with currentDate of 1/6/21 needs -1 logic instead of -11 logic
    //because 12/27/20 to 1/2/21 is the 1st week of the year technically
    if (startYear == currentYear - 1 && endYear == currentYear && currentMonth == 1) {
      if (startWeek == currentWeek && endWeek == currentWeek && startDay == 0 && endDay == 6) {
        return dateRange = "THIS WEEK";
      } else if (startWeek == currentWeek - 1 && endWeek == currentWeek - 1 && startDay == 0 && endDay == 6) {
        return dateRange = "LAST WEEK";
      } else if (startMonth - 11 == currentMonth && endMonth - 11 == currentMonth &&
        startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "LAST MONTH";
      }
    }

    //Handles cases where startDate and endDate are both last year but are still within the
    //realm of 'last week', and 'last month' based on the current date. 'This week' should not
    //be possible in this situation since the endDate would have to be in the new year.
    if (startYear == currentYear - 1 && endYear == currentYear - 1 && currentMonth == 1) {
      if (startWeek - 51 == currentWeek && endWeek - 51 == currentWeek && startDay == 0 && endDay == 6) {
        return dateRange = "LAST WEEK";
      } else if (startMonth - 11 == currentMonth && endMonth - 11 == currentMonth &&
        startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "LAST MONTH";
      }
    }

    //Lets not use this for anything over a year old.
    if (startDaysFromCurrent <= 365) {
      if (startMonth == 1 && endMonth == 1 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M01";
      } else if (startMonth == 2 && endMonth == 2 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M02";
      } else if (startMonth == 3 && endMonth == 3 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M03";
      } else if (startMonth == 4 && endMonth == 4 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M04";
      } else if (startMonth == 5 && endMonth == 5 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M05";
      } else if (startMonth == 6 && endMonth == 6 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M06";
      } else if (startMonth == 7 && endMonth == 7 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M07";
      } else if (startMonth == 8 && endMonth == 8 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M08";
      } else if (startMonth == 9 && endMonth == 9 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M09";
      } else if (startMonth == 10 && endMonth == 10 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M10";
      } else if (startMonth == 11 && endMonth == 11 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M11";
      } else if (startMonth == 12 && endMonth == 12 && startDateDayOfMonth == 1 && endDateDayOfMonth == endOfMonthNumber) {
        return dateRange = "M12";
      }
    }

    return dateRange;
  }

  public static getDateRange(dateRange: string, effectiveDateTime: Date = null, weekBegins: number = 1, smart: boolean = true): { beginningDateTime: Date, endingDateTime: Date } {

    if (!dateRange) {
      return { beginningDateTime: new Date(), endingDateTime: new Date() };
    }

    let beginningDateTime: Date = null;
    let endingDateTime: Date = null;

    // Validate input parameters
    dateRange = dateRange.toUpperCase().trim();
    if (!effectiveDateTime) {
      effectiveDateTime = new Date();
    }
    if (!weekBegins || weekBegins < 1 || weekBegins > 7) {
      weekBegins = 1;
    }

    // For month and week date ranges we may have a qualifier after a tilde ~ marker telling us the day of week or month we end on.
    let qualifier: string = "";
    let qualifierValue: number = 0;
    if (Helper.contains(dateRange, "~")) {
      qualifier = dateRange.substring(dateRange.indexOf("~")).replace("~", "").trim();
      dateRange = Helper.left(dateRange, dateRange.indexOf("~")).replace("~", "").trim();
      if (qualifier && !Helper.equals(qualifier, "LAST", true)) {
        qualifierValue = parseInt(qualifier, 10);
      }
    }

    // If we have a qualifier and it's not LAST then we need to take action
    if (dateRange === "WTD" || dateRange === "THIS WEEK" || dateRange === "LAST WEEK") {
      if (qualifier && !Helper.equals(qualifier, "LAST", true) && qualifierValue >= 1 && qualifierValue <= 7) {
        // Before calculating the week based date range adjust when the week begins to the day of week after the week ends (per the qualifier)
        weekBegins = qualifierValue + 1;
        if (weekBegins > 7) {
          weekBegins = 1;
        }
      }
    }

    // Keep year in a separate value that we can reference as needed
    let year: number = effectiveDateTime.getFullYear();
    // Now if we were told to be smart then if this is a month and it's in
    // the future then assume last year unless the year was actually passed
    if (smart && Helper.startsWith(dateRange, "M") && dateRange.length == 3) {
      // Would we really want Nov 97 if today is Jan 97?  No we would be asking for Nov 96.
      const month: number = parseInt(dateRange.substring(1), 10);
      if (month && month > (effectiveDateTime.getMonth() + 1)) {
        year--;
      }
    } else if (smart && Helper.startsWith(dateRange, "Q") && dateRange.length == 2) {
      // Would we really want Q4 of current year if it's not Q4 yet?  No we would be asking for Q4 of the previous year.
      const quarter: number = parseInt(dateRange.substring(1), 10);
      let month = 0;
      if (quarter === 1) {
        month = 1;
      } else if (quarter === 2) {
        month = 4;
      } else if (quarter === 3) {
        month = 7;
      } else {
        month = 10;
      }
      if (month > (effectiveDateTime.getMonth() + 1)) {
        year--;
      }
    }

    // Default date range to effective date range in case we don't find what we're looking for
    beginningDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 0, 0, 0, 0);
    endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);

    // Now based on dateRange value requested calculate beginning and ending dates
    if (dateRange === "YTD") {
      beginningDateTime = new Date(year, 0, 1, 0, 0, 0, 0);
      endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "LAST YEAR") {
      beginningDateTime = new Date(year - 1, 0, 1, 0, 0, 0, 0);
      endingDateTime = new Date(year - 1, 11, 31, 23, 59, 59, 997);
    } else if (dateRange === "MTD") {
      beginningDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), 1, 0, 0, 0, 0);
      endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);
    } else if (Helper.startsWith(dateRange, "M") && dateRange.length === 3) {
      const month: number = parseInt(dateRange.substring(1), 10);
      if (month) {
        beginningDateTime = new Date(year, month - 1, 1, 0, 0, 0);
        endingDateTime = endOfMonth(beginningDateTime);
      }
    } else if (dateRange === "THIS MONTH") {
      beginningDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), 1, 0, 0, 0, 0);
      endingDateTime = endOfMonth(beginningDateTime);
    } else if (dateRange === "LAST MONTH") {
      beginningDateTime = startOfMonth(addMonths(effectiveDateTime, -1));
      endingDateTime = endOfMonth(beginningDateTime);
    } else if (dateRange === "WTD") {
      // TODO respect weekBegins
      beginningDateTime = startOfWeek(effectiveDateTime);
      endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "THIS WEEK") {
      // TODO respect weekBegins
      beginningDateTime = startOfWeek(effectiveDateTime);
      endingDateTime = endOfWeek(beginningDateTime);
    } else if (dateRange === "LAST WEEK") {
      // TODO respect weekBegins
      beginningDateTime = startOfWeek(addWeeks(effectiveDateTime, -1));
      endingDateTime = endOfWeek(beginningDateTime);
    } else if (dateRange === "LAST 7 DAYS" || dateRange === "PAST WEEK") {
      //endingDateTime = moment(effectiveDateTime).add(-1, "day").endOf("day").toDate();
      // Old logic was last 7 complete days (through last night at midnight) but we have changed
      // this to be inclusive of today to match user expected behavior.
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -6));
      endingDateTime = endOfDay(effectiveDateTime);
    } else if (dateRange === "LAST 3 DAYS") {
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -2));
      endingDateTime = endOfDay(effectiveDateTime);
    } else if (dateRange === "PAST MONTH") {
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -29));
      endingDateTime = endOfDay(effectiveDateTime);
    } else if (dateRange === "PAST 3 MONTHS") {
      beginningDateTime = startOfDay(addMonths(effectiveDateTime, -3));
      endingDateTime = endOfDay(effectiveDateTime);
    } else if (dateRange === "PAST YEAR") {
      beginningDateTime = startOfDay(addYears(effectiveDateTime, -1));
      endingDateTime = endOfDay(effectiveDateTime);
    } else if (dateRange === "TODAY") {
      beginningDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 0, 0, 0, 0);
      endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "YESTERDAY") {
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -1));
      endingDateTime = new Date(beginningDateTime.getFullYear(), beginningDateTime.getMonth(), beginningDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "2 DAYS AGO") {
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -2));
      endingDateTime = new Date(beginningDateTime.getFullYear(), beginningDateTime.getMonth(), beginningDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "3 DAYS AGO") {
      beginningDateTime = startOfDay(addDays(effectiveDateTime, -3));
      endingDateTime = new Date(beginningDateTime.getFullYear(), beginningDateTime.getMonth(), beginningDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "LAST SUN" || dateRange === "LAST MON" || dateRange === "LAST TUE" || dateRange === "LAST WED" ||
      dateRange === "LAST THU" || dateRange === "LAST FRI" || dateRange === "LAST SAT") {
      // Offset for the desired day of week
      let offset: number = 0;
      if (dateRange === "LAST SUN") {
        offset = 1;
      } else if (dateRange === "LAST MON") {
        offset = 2;
      } else if (dateRange === "LAST TUE") {
        offset = 3;
      } else if (dateRange === "LAST WED") {
        offset = 4;
      } else if (dateRange === "LAST THU") {
        offset = 5;
      } else if (dateRange === "LAST FRI") {
        offset = 6;
      } else if (dateRange === "LAST SAT") {
        offset = 7;
      }
      // Get the day of week but make it 1-based instead of 0-based
      const dow: number = effectiveDateTime.getDay() + 1;
      // Now subtract our requested day of week offset to get the decrement value
      const days: number = (dow - offset);
      // Now if our current day of week is less than or equal to the desired day of week we
      // subtract 7 days plus our decrement value otherwise just subtract the decrement value
      if (dow <= offset) {
        beginningDateTime = startOfDay(addDays(effectiveDateTime, -7 - days));
      } else {
        beginningDateTime = startOfDay(addDays(effectiveDateTime, -1 * days));
      }
      // Now set end of day
      endingDateTime = new Date(beginningDateTime.getFullYear(), beginningDateTime.getMonth(), beginningDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "QTD") {
      beginningDateTime = startOfQuarter(effectiveDateTime);
      endingDateTime = new Date(effectiveDateTime.getFullYear(), effectiveDateTime.getMonth(), effectiveDateTime.getDate(), 23, 59, 59, 997);
    } else if (dateRange === "THIS QUARTER") {
      beginningDateTime = startOfQuarter(effectiveDateTime);
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "LAST QUARTER") {
      beginningDateTime = startOfQuarter(addMonths(effectiveDateTime, -3));
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "Q1") {
      beginningDateTime = new Date(year, 0, 1, 0, 0, 0, 0);
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "Q2") {
      beginningDateTime = new Date(year, 3, 1, 0, 0, 0);
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "Q3") {
      beginningDateTime = new Date(year, 6, 1, 0, 0, 0);
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "Q4") {
      beginningDateTime = new Date(year, 9, 1, 0, 0, 0);
      endingDateTime = endOfQuarter(beginningDateTime);
    } else if (dateRange === "WINTER") {
      beginningDateTime = new Date(year, 11, 21, 0, 0, 0, 0);
      endingDateTime = new Date((year + 1), 2, 20, 23, 59, 59, 997);
    } else if (dateRange === "SPRING") {
      beginningDateTime = new Date(year, 2, 21, 0, 0, 0, 0);
      endingDateTime = new Date(year, 5, 20, 23, 59, 59, 997);
    } else if (dateRange === "SUMMER") {
      beginningDateTime = new Date(year, 5, 21, 0, 0, 0, 0);
      endingDateTime = new Date(year, 8, 20, 23, 59, 59, 997);
    } else if (dateRange === "FALL") {
      beginningDateTime = new Date(year, 8, 21, 0, 0, 0, 0);
      endingDateTime = new Date(year, 11, 20, 23, 59, 59, 997);
    } else if (dateRange === "CUSTOM") {
      beginningDateTime = null;
      endingDateTime = null;
    } else {
      // If we were asked for CUSTOM or were unable to figure out what the user wanted for dateRange then return false
      Log.errorMessage(`Unable to calculate date range for ${dateRange}`);
    }

    // For seasons if we are in the future then roll back a year
    if (dateRange === "WINTER" || dateRange === "SPRING" || dateRange === "SUMMER" || dateRange === "FALL") {
      if (beginningDateTime > effectiveDateTime) {
        beginningDateTime = addYears(beginningDateTime, -1);
        endingDateTime = addYears(endingDateTime, -1);
      }
    }

    // If we have a qualifier and it's not LAST then we need to take action
    if (dateRange === "MTD" || (Helper.startsWith(dateRange, "M") && dateRange.length == 3) || dateRange === "THIS MONTH" || dateRange === "LAST MONTH") {
      if (qualifier && !Helper.equals(qualifier, "LAST", true) && qualifierValue < endingDateTime.getDate()) {
        beginningDateTime = addDays(addMonths(beginningDateTime, -1), qualifierValue);
        endingDateTime = addDays(endingDateTime, -1 * (endingDateTime.getDate() - qualifierValue));
      }
    }

    return { beginningDateTime: beginningDateTime, endingDateTime: endingDateTime };

  }


  public static isHtml(value: string): boolean {
    if (!value) {
      return false;
    }
    const upper = value.toUpperCase();
    if (Helper.contains(upper, "<P", false)) {
      return true;
    } else if (Helper.contains(upper, "/>", false)) {
      return true;
    } else if (Helper.contains(upper, "</", false) && Helper.contains(upper, ">", false)) {
      return true;
    }
    // Made it this far then don't think this is html
    return false;
  }


  public static isValidEmailAddress(value: string): boolean {
    if (!value) {
      return false;
    }
    if (!Helper.contains(value, "@", true)) {
      return false;
    } else if (!Helper.contains(value, ".", true)) {
      return false;
    }
    // Made it this far we appear to be valid
    return true;
  }


  public static htmlEscape(str: string): string {
    const value: string = str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return value;
  }

  public static htmlUnescape(str: string): string {
    const value: string = str.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    return value;
  }

  public static htmlEventIsRightMouseButton(event: any): boolean {

    if (!event) {
      return false;
    }

    let isRightButton = false;
    if ("which" in event) {
      // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
      isRightButton = (event.which === 3);
    } else if ("button" in event) {
      // IE, Opera
      isRightButton = (event.button === 2);
    }

    return isRightButton;

  }

  public static htmlEventPathSearch(event: any, value: string, type: "id" | "class", operator: "equals" | "contains" | "startsWith"): boolean {

    if (!event || !event.path || event.path.length === 0) {
      return false;
    }

    let found: boolean = false;

    event.path.some((path) => {
      if (type === "id" && path && path.id) {
        if (operator === "equals") {
          if (Helper.equals(path.id, value, true)) {
            found = true;
            return true; // Done searching
          }
        } else if (operator === "contains") {
          if (Helper.contains(path.id, value, true)) {
            found = true;
            return true; // Done searching
          }
        } else if (operator === "startsWith") {
          if (Helper.startsWith(path.id, value, true)) {
            found = true;
            return true; // Done searching
          }
        }
      } else if (type === "class" && path && path.className) {
        if (operator === "equals") {
          if (Helper.equals(path.className, value, true)) {
            found = true;
            return true; // Done searching
          }
        } else if (operator === "contains") {
          if (Helper.contains(path.className, value, true)) {
            found = true;
            return true; // Done searching
          }
        } else if (operator === "startsWith") {
          if (Helper.startsWith(path.className, value, true)) {
            found = true;
            return true; // Done searching
          }
        }
      }
      // Keep searching
      return false;
    });

    return found;

  }

  /**
   * Removes all but alphanumeric values from string.
   * @param str
   * @see https://stackoverflow.com/a/9364527/3313877
   */
  public static toAlphaNumericOnly(str: string): string {
    if (!str) {
      return "";
    }
    return str.replace(/[^0-9a-z]/gi, '');
  }


  /**
   * Capitalizes first letter of each word.
   * @param str
   * @see http://stackoverflow.com/a/4878800
   */
  public static toTitleCase(str: string): string {
    if (!str) {
      return "";
    }
    const value: string = str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    return value;
  }

  /**
   * Capitalizes first letter of the string. (not first letter of each word.  See toTitleCase for that.)
   * @param str
   */
  public static capitalizeFirstLetterOfString(str: string): string {
    if (!str) {
      return "";
    }
    const value: string = str.toLowerCase().replace(/^\w/, function (c) { return c.toUpperCase(); });
    return value;
  }

  /**
  Make string plural when count is >1 otherwise makes singular.  Option to include the count in the output.
  TODO look into using this: https://github.com/blakeembrey/pluralize
  */
  public static plural(input: string, count: number = 2, includeCount: boolean = false): string {

    const plural = {
      '(quiz)$': "$1zes",
      '^(ox)$': "$1en",
      '([m|l])ouse$': "$1ice",
      '(matr|vert|ind)ix|ex$': "$1ices",
      '(x|ch|ss|sh)$': "$1es",
      '([^aeiouy]|qu)y$': "$1ies",
      '(hive)$': "$1s",
      '(?:([^f])fe|([lr])f)$': "$1$2ves",
      '(shea|lea|loa|thie)f$': "$1ves",
      'sis$': "ses",
      '([ti])um$': "$1a",
      '(tomat|potat|ech|her|vet)o$': "$1oes",
      '(bu)s$': "$1ses",
      '(alias)$': "$1es",
      '(octop)us$': "$1i",
      '(ax|test)is$': "$1es",
      '(us)$': "$1es",
      '([^s]+)$': "$1s"
    };

    const singular = {
      '(quiz)zes$': "$1",
      '(matr)ices$': "$1ix",
      '(vert|ind)ices$': "$1ex",
      '^(ox)en$': "$1",
      '(alias)es$': "$1",
      '(octop|vir)i$': "$1us",
      '(cris|ax|test)es$': "$1is",
      '(shoe)s$': "$1",
      '(o)es$': "$1",
      '(bus)es$': "$1",
      '([m|l])ice$': "$1ouse",
      '(x|ch|ss|sh)es$': "$1",
      '(m)ovies$': "$1ovie",
      '(s)eries$': "$1eries",
      '([^aeiouy]|qu)ies$': "$1y",
      '([lr])ves$': "$1f",
      '(tive)s$': "$1",
      '(hive)s$': "$1",
      '(li|wi|kni)ves$': "$1fe",
      '(shea|loa|lea|thie)ves$': "$1f",
      '(^analy)ses$': "$1sis",
      '((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$': "$1$2sis",
      '([ti])a$': "$1um",
      '(n)ews$': "$1ews",
      '(h|bl)ouses$': "$1ouse",
      '(corpse)s$': "$1",
      '(us)es$': "$1",
      's$': ""
    };

    const irregular = {
      'move': 'moves',
      'foot': 'feet',
      'goose': 'geese',
      'sex': 'sexes',
      'child': 'children',
      'man': 'men',
      'tooth': 'teeth',
      'person': 'people'
    };

    const uncountable = [
      'sheep',
      'fish',
      'deer',
      'moose',
      'series',
      'species',
      'money',
      'rice',
      'information',
      'equipment'
    ];

    // save some time in the case that singular and plural are the same
    if (uncountable.indexOf(input.toLowerCase()) >= 0) {
      if (includeCount) {
        return `${count} ${input}`;
      } else {
        return input;
      }
    }

    // check for irregular forms
    for (const word in irregular) {

      if (count <= 1) {
        var pattern = new RegExp(irregular[word] + '$', 'i');
        var replace = word;
      } else {
        var pattern = new RegExp(word + '$', 'i');
        var replace: string = irregular[word];
      }
      if (pattern.test(input)) {
        if (includeCount) {
          return `${count} ${input.replace(pattern, replace)}`;
        } else {
          return input.replace(pattern, replace);
        }
      }
    }

    let array: any = plural;
    if (count <= 1) {
      array = singular;
    }

    // check for matches using regular expressions
    for (var reg in array) {
      let pattern = new RegExp(reg, 'i');
      if (pattern.test(input)) {
        if (includeCount) {
          return `${count} ${input.replace(pattern, array[reg])}`;
        } else {
          return input.replace(pattern, array[reg]);
        }
      }
    }

    if (includeCount) {
      return `${count} ${input}`;
    } else {
      return input;
    }

  }


  /**
  Can be used to format a camel case or title case identifier as separate words.
  @example
  // "My Title Case String"
  Helper.FormatIdentifierWithSpaces( "MyTitleCaseString" );
  // "Contact Id"
  Helper.FormatIdentifierWithSpaces( "CONTACT_ID" );
  */
  public static formatIdentifierWithSpaces(identifier: string) {
    if (!identifier) {
      return "";
    }
    if (typeof identifier !== 'string') {
      return "";
    }
    // Special use case for words with underscores or where it's all one case
    if (Helper.contains(identifier, "_") || identifier === identifier.toLowerCase() || identifier === identifier.toUpperCase()) {
      identifier = Helper.replaceAll(identifier, "_", " ");
      return identifier.toLowerCase()
        .split(' ')
        .map(i => i[0].toUpperCase() + i.substring(1))
        .join(' ');
    }
    return identifier
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/^./, function (str) { return str.toUpperCase(); });
  }


  /**
   * Note: Regular expressions contain special (meta) characters, and as such it is dangerous to blindly pass an argument in the find function above without pre-processing it to escape those characters.
   * This is covered in the Mozilla Developer Network's JavaScript Guide on Regular Expressions, where they present this utility function.
   * @param input
   * @returns {}
   */
  public static escapeRegExp(input: string) {
    const value: string = input.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return value;
  }

  public static lineFeedToHtmlBreak(input: string): string {
    const value: string = input.replace(/\n/g, '<br/>');
    return value;
  }

  /**
  Used to replace all occurrences in a string.
  */
  public static replaceAll(input: string, find: string, replace: string) {
    if (!input) {
      return "";
    }
    find = Helper.escapeRegExp(find);
    return input.replace(new RegExp(find, 'g'), replace);
  }

  public static left(input: string, length: number, ellipses: boolean = false): string {
    if (!input || input === "" || !length || length === 0) {
      return "";
    }
    if (Helper.isObject(input)) {
      input = JSON.stringify(input);
    } else {
      input = input.toString();
    }
    if (ellipses && input.length > length) {
      if (length > 3) {
        length = length - 3;
      }
      return input.substring(0, length) + "...";
    }
    return input.substring(0, length);
  }

  public static right(input: string, length: number): string {
    if (length <= 0) {
      return "";
    } else if (length > String(input).length) {
      return input;
    } else {
      var len = String(input).length;
      return String(input).substring(len, len - length);
    }
  }


  /**
   * Determine if string appears to be json.
   * @param json
   * @returns
   */
  public static isJson(json: string): boolean {
    if (!json) {
      return false;
    }
    json = json.trim();
    if (Helper.startsWith(json, "{", true) && Helper.endsWith(json, "}", true)) {
      return true;
    }
    if (Helper.startsWith(json, "[", true) && Helper.endsWith(json, "]", true)) {
      return true;
    }
    return false;
  }


  // http://stackoverflow.com/a/7220510
  public static jsonStringify(obj: any, indentation: number = 4, syntaxHighlight: boolean = true, replacer: any = null): string {
    let json: string = JSON.stringify(obj, replacer, indentation);
    if (!syntaxHighlight) {
      return json;
    }
    // Apply style to highlight the json syntax
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var style = 'color: darkorange;';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          style = 'color: red;';
        } else {
          style = 'color: green;';
        }
      } else if (/true|false/.test(match)) {
        style = 'color: blue;';
      } else if (/null/.test(match)) {
        style = 'color: magenta;';
      }
      return '<span style="' + style + '">' + match + '</span>';
    });
  }


  /**
  This pads a value with the specified padding.  Example: PadString('0000000000',123,true);
  @param {string} pad The padding string (e.g. '00000000000000').
  @param {any} str The value to pad.
  @param {boolean} padLeft When true the padding is applied to the left of the value.
  @returns {string} The padded string.
  */
  public static padString(pad: string, str: any, padLeft: boolean): string {
    if (str == undefined) return pad;
    if (padLeft) {
      return (pad + str).slice(-pad.length);
    } else {
      return (str + pad).substring(0, pad.length);
    }
  }


  /**
  This pads a number with the specified padding.  Example: Pad(48484,10,"0");
  @param {number} num The number to pad.
  @param {number} width The desired length of the resulted padded string.
  @param {string} padWith The character to use for padding.
  @returns {string} The padded string.
  */
  public static pad(num: number, width: number, padWith: string = "0"): string {
    if (num === undefined || num === null) {
      return "";
    }
    padWith = padWith || "0";
    const numAsString: string = num.toString();
    return numAsString.length >= width ?
      numAsString :
      new Array(width - numAsString.length + 1).join(padWith) + numAsString;
  }


  public static fileToBase64(file: Blob): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    return promise;
  }


  public static toInt(value: any, defaultValue: number = 0): number {
    if (!value) {
      return defaultValue;
    }
    return parseInt(value.toString(), 10);
  }


  public static toString(value: any, defaultValue: string = ""): string {
    if (value === null || value === undefined) {
      return defaultValue;
    }
    return value.toString();
  }



  /**
   * Converts a number from one base to another.
   * @param number
   * @param frombase
   * @param tobase
   * @example
   * example 1: base_convert('A37334', 16, 2);
   * returns 1: '101000110111001100110100'
   * @author
   * original by: Philippe Baumann
   * improved by: Rafał Kukawski (http://blog.kukawski.pl)
   * @returns {}
   */
  public static baseConvert(number, frombase, tobase): string {
    // TODO not sure this is working right when GUID goes base 16 -> 36 and outputs dmszodzecio00000000000000 (what are all these 00000 values?)
    const parsed: number = parseInt(number + '', frombase | 0);
    //return parsed.toString();
    return parsed.toString(tobase | 0);
  }

  /**
   * Creates a GUID.
   * @see http://www.ietf.org/rfc/rfc4122.txt
   * @returns {}
   */
  public static createGuid(): string {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
  }

  /**
   * Creates a base 36 guid-ish value.
   * @returns {}
   */
  public static createBase36Guid(length: number = 15): string {
    if (!length || length < 5) {
      length = 5;
    }
    var s = [];
    var digits = "0123456789abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < length; i++) {
      s[i] = digits.substr(Math.floor(Math.random() * 36), 1);
    }
    var uuid = s.join("");
    return uuid;
  }


  // Seems like BaseConvert has issues...
  ///**
  // * Create a base 36 GUID.
  // * @returns {}
  // */
  //public static CreateBase36Guid(): string {
  //    var guid: string = Helper.ReplaceAll(Helper.CreateGuid(), "-", "");
  //    //return guid;
  //    return Helper.BaseConvert(guid, 16, 36);
  //}


  public static randomInteger(negative: boolean = false, max: number = Constants.Numbers.MaxInt32): number {
    let integer: number = Math.floor(Math.random() * max);
    if ((negative && integer > 0) || (!negative && integer < 0)) {
      integer = (-1 * integer);
    }
    return integer;
  }



  /**
  Sorts an array of numbers
  @param {number[]} array The array to sort.
  @param {boolean} descending When true the items are sorted in descending order.
  @returns {number[]} The sorted array.
  */
  public static arraySortNumbers(array: number[], descending: boolean = false): number[] {
    if (!array || array.length === 0) {
      return [];
    }
    if (descending) {
      return array.sort((a, b) => (a < b ? 1 : a > b ? -1 : 0));
    }
    return array.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
  }


  /**
  Sorts an array of strings
  @param {string[]} array The array to sort.
  @param {boolean} descending When true the items are sorted in descending order.
  @returns {string[]} The sorted array.
  */
  public static arraySortStrings(array: string[], descending: boolean = false): string[] {
    if (!array || array.length === 0) {
      return [];
    }
    if (descending) {
      return array.sort((a, b) => b.localeCompare(a));
    }
    return array.sort((a, b) => a.localeCompare(b));
  }


  /**
  Sorts an array of objects by the specified property and descending flag.
  @param {T[]} array The array to sort.
  @param {string} property The name of the property to sort by.
  @param {boolean} descending When true the items are sorted in descending order.
  @param {boolean} ignoreCase When true the items are sorted as case insensitive strings.
  @returns {T[]} The sorted array.
  */
  public static arraySort<T>(array: T[], property: string, descending: boolean = false, ignoreCase: boolean = undefined): T[] {
    if (!array || array.length === 0) {
      return [];
    }
    if (descending) {
      if (ignoreCase) {
        return Enumerable.from(array)
          .orderByDescending(function (item) { return item[property].toString().toUpperCase(); })
          .toArray();
      } else {
        return Enumerable.from(array)
          .orderByDescending(function (item) { return item[property]; })
          .toArray();
      }
    }
    if (ignoreCase) {
      return Enumerable.from(array)
        .orderBy(function (item) { return item[property].toString().toUpperCase(); })
        .toArray();
    } else {
      return Enumerable.from(array)
        .orderBy(function (item) { return item[property]; })
        .toArray();
    }
  }


  public static arraySort2<T, K extends keyof T>(values: T[], property: K, descending: boolean = false, ignoreCase: boolean = undefined): T[] {

    const reverse = (descending ? -1 : 1);

    return values.sort((a, b) => {

      if (ignoreCase) {
        if (a[property].toString().toUpperCase() < b[property].toString().toUpperCase()) {
          return (-1 * reverse);
        }
      } else {
        if (a[property] < b[property]) {
          return (-1 * reverse);
        }
      }

      if (ignoreCase) {
        if (a[property].toString().toUpperCase() > b[property].toString().toUpperCase()) {
          return (1 * reverse);
        }
      } else {
        if (a[property] > b[property]) {
          return (1 * reverse);
        }
      }

      return 0;

    });

  }


  public static arrayDistinct<T>(array: T[]): T[] {
    // For simple values we do this since Set will remove duplicates
    return Array.from(new Set(array));
  }


  // /**
  //  * Find index of an object in an array of objects based on a property value.
  //  * @param array
  //  * @param property The property of the object to search
  //  * @param value The value of the property to find
  //  * @returns {}
  //  */
  // public static arrayElementFindIndexByPropertyValue(array: any[], property: string, value: any) {
  //   for (var index = 0; index < array.length; index++) {
  //     if (array[index][property]) {
  //       if (array[index][property] === value) {
  //         return index;
  //       }
  //     }
  //   }
  //   return -1;
  // }

  // /**
  //  * Move an element within an array from a drag and drop operation.
  //  * @param array
  //  * @param property The name of the property in an object to search
  //  * @param dragValue The value of the property to move
  //  * @param dropValue The value of the property to be replaced
  //  * @param fixedLocationDrop when < 0 then drop at top of list; when > 0 then drop at end of list; when = 0 then drop at the dropValue position.
  //  * @returns {}
  //  */
  // public static arrayElementDragAndDrop(array: any[], property: string, dragValue: any, dropValue: any, fixedLocationDrop: number): any[] {

  //   // Get our array index for our drag and drop objects
  //   var dragIndex: number = Helper.arrayElementFindIndexByPropertyValue(array, property, dragValue);
  //   var dropIndex: number = -1;
  //   // Drop can be complicated by dropping outside of the array.  The fixedLocationDrop value is < 0 when we are dropping at the
  //   // top of the array; > 0 when we are dropping at the bottom of the array; = 0 when we are dropping into the array and we can
  //   // use dropValue for determining that position.
  //   if (fixedLocationDrop < 0) {
  //     dropIndex = -1;
  //   } else if (fixedLocationDrop > 0) {
  //     dropIndex = array.length + 1;
  //   } else {
  //     dropIndex = Helper.arrayElementFindIndexByPropertyValue(array, property, dropValue);
  //   }

  //   // Now move the array elements
  //   return Helper.arrayElementMove(array, dragIndex, dropIndex);
  // }

  /**
   * Move an array element from one position to another.
   * To move to the end you can use a high new index number and we'll adjust that to the end element.
   * Returns an object that includes an array of all items as well as an array of changed items so
   * the changes can be persisted.  Note that the list of changed items will always be empty except when
   * a displayOrderPropertyName is specified since that is the only scenario in which object values
   * are modified.
   * @see http://stackoverflow.com/a/32751487
   * @param array
   * @param oldIndex
   * @param newIndex
   * @param displayOrderPropertyName
   * @returns object { allItems: T[], changedItems: T[] }
   */
  public static arrayElementMove<T>(array: T[], oldIndex: number, newIndex: number, displayOrderPropertyName: string = ""): { allItems: T[], changedItems: T[] } {
    // Stay within bounds
    if (!array || array.length === 0 || oldIndex === undefined || newIndex === undefined || oldIndex < 0 || newIndex < 0 || oldIndex > array.length) {
      console.log("Function arrayElementMove received input that was out of bounds.  No action taken.");
      return { allItems: array, changedItems: [] };
    }
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    // Make the move
    try {
      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    } catch (err) {
      Log.errorMessage(err);
    }
    // With a display order property involved we want to fit our display order in relation to it's new home.  That may mean
    // renumbering only one object if there is a gap or it may mean renumbering the whole collection.
    if (displayOrderPropertyName && array.length > 1) {
      return Helper.arrayUpdateDisplayOrder(array, newIndex, displayOrderPropertyName);
    }
    return { allItems: array, changedItems: [] };
  }

  /**
   * Updates display order of an array element as well as those around it if the updated display order
   * cannot fit in the gap between other elements.  Returns an object that includes an array of all
   * items as well as an array of changed items so the changes can be persisted.
   * @param array
   * @param currentIndexOfMovedItem
   * @param displayOrderPropertyName
   * @returns object { allItems: T[], changedItems: T[] }
   */
  public static arrayUpdateDisplayOrder<T>(array: T[], currentIndexOfMovedItem: number, displayOrderPropertyName: string): { allItems: T[], changedItems: T[] } {
    // Stay without bounds
    if (!array || array.length === 0 || currentIndexOfMovedItem === undefined || currentIndexOfMovedItem < 0) {
      Log.errorMessage("Function arrayUpdateDisplayOrder received input that was out of bounds.  No action taken.");
      return { allItems: array, changedItems: [] };
    }
    if (currentIndexOfMovedItem >= array.length) {
      currentIndexOfMovedItem = array.length - 1;
    }
    // If we don't have a display order property name or we only have one item in our array then we're done since this method
    // is all about renumbering the display order property values in an array.
    if (!displayOrderPropertyName || array.length <= 1) {
      return { allItems: array, changedItems: [] };
    }
    // We keep a list of changed items so we can notify which items may need to have their display order values updated in the api
    let changes: T[] = [];
    // With a display order property involved we want to fit our display order in relation to it's new home.  That may mean
    // renumbering only one object if there is a gap or it may mean renumbering the whole collection.
    try {
      let renumberAll: boolean = false;
      let beforeDisplayOrder: number = 0;
      let afterDisplayOrder: number = 0;
      let currentDisplayOrder: number = array[currentIndexOfMovedItem][displayOrderPropertyName];
      if (currentDisplayOrder === undefined || currentDisplayOrder === null || typeof currentDisplayOrder !== "number") {
        array[currentIndexOfMovedItem][displayOrderPropertyName] = 0;
        changes.push(array[currentIndexOfMovedItem]);
        currentDisplayOrder = 0;
      }
      if (currentIndexOfMovedItem === 0) {
        // We are the first in the list... see what the display order for the item after us is
        afterDisplayOrder = array[currentIndexOfMovedItem + 1][displayOrderPropertyName];
        // If we are greater than or equal to that display order then change our display order to be midway between that and zero
        if (currentDisplayOrder >= afterDisplayOrder) {
          let proposedDisplayOrder = Math.floor(afterDisplayOrder / 2);
          if (proposedDisplayOrder > 0) {
            array[currentIndexOfMovedItem][displayOrderPropertyName] = proposedDisplayOrder;
            changes.push(array[currentIndexOfMovedItem]);
            //console.error("new display order", proposedDisplayOrder);
          } else {
            renumberAll = true;
          }
        }
      } else if (currentIndexOfMovedItem === (array.length - 1)) {
        // We are the last in the list... see what the display order for the item before us is
        beforeDisplayOrder = array[currentIndexOfMovedItem - 1][displayOrderPropertyName];
        // If we are less than or equal to that display order then change our display order to be +100 after it
        if (currentDisplayOrder <= beforeDisplayOrder) {
          array[currentIndexOfMovedItem][displayOrderPropertyName] = (beforeDisplayOrder + 100);
          changes.push(array[currentIndexOfMovedItem]);
        }
      } else {
        // We are between items in the list... see what the display order for the item before and after is
        beforeDisplayOrder = array[currentIndexOfMovedItem - 1][displayOrderPropertyName];
        afterDisplayOrder = array[currentIndexOfMovedItem + 1][displayOrderPropertyName];
        // If we are not already between those numbers then stick us in there
        if (currentDisplayOrder <= beforeDisplayOrder || currentDisplayOrder >= afterDisplayOrder) {
          let proposedDisplayOrder = Math.floor((beforeDisplayOrder + afterDisplayOrder) / 2);
          if (proposedDisplayOrder > 0 && proposedDisplayOrder > beforeDisplayOrder && proposedDisplayOrder < afterDisplayOrder) {
            array[currentIndexOfMovedItem][displayOrderPropertyName] = proposedDisplayOrder;
            changes.push(array[currentIndexOfMovedItem]);
          } else {
            renumberAll = true;
          }
        }
      }
      // If we hit flag that we need to renumber all then do that now
      if (renumberAll) {
        // Incrementing display order by 100 gives us room to change find a display order between two values when
        // we make a change which minimizes how often we renumber all of them and, therefore, minimizes the number
        // of items that have to be changed in our back end.
        currentDisplayOrder = 100;
        array.forEach(item => {
          item[displayOrderPropertyName] = currentDisplayOrder;
          currentDisplayOrder += 100;
        });
        // Everything got renumbered so all array elements changed
        changes = [...array];
      }
    } catch (err) {
      Log.errorMessage(err);
      return { allItems: array, changedItems: [...array] };
    }
    return { allItems: array, changedItems: changes };
  }


  /**
   * Like array.find except instead of undefined when no match is found we return defaultValue.
   * @param array
   * @param callbackfn
   * @param defaultValue
   * @returns
   */
  public static arrayFirstOrDefault<T>(array: T[], callbackfn: (value: T, index: number, array: T[]) => any, defaultValue: T = null): T {
    // let matches = array.filter(callbackfn);
    // if (!matches || matches.length === 0) {
    //   return defaultValue;
    // }
    // return matches[0];
    const match = array.find(callbackfn);
    if (!match) {
      return defaultValue;
    }
    return match;
  }

  /**
   * This function will update the array with value based on index.  If index is -1 or
   * out of range for the array contents the value will be pushed into the array.
   * @param array
   * @param value
   * @param index - use undefined/null if we should find the index.  -1 will force add.
   */
  public static arrayAddOrUpdateValue<T>(array: T[], value: T, index: number): void {
    if (!array) {
      return;
    }
    // Undefined or null index is request to determine if add or edit
    if (index === undefined || index === null) {
      index = array.findIndex(x => x === value);
    }
    // Index of -1 or out of bounds means add otherwise we will edit
    if (index <= -1 || array.length === 0 || array.length <= index) {
      array.push(value);
    } else {
      array[index] = value;
    }
    return;
  }

  public static arrayRemoveValue<T>(array: T[], value: T, index: number = -1): boolean {
    if (!array || array.length === 0) {
      return false;
    }
    if (index === undefined || index === null || index < 0) {
      index = array.findIndex(x => x === value);
    }
    if (index === -1) {
      return false;
    }
    let deleted: T[] = array.splice(index, 1);
    return (deleted.length > 0);
  }

  public static arrayIncludesValue<T>(array: T[], value: T): boolean {
    if (!array || array.length === 0) {
      return false;
    }
    return (array.findIndex(x => x === value) > -1);
  }

  /**
   * Get maximum numeric value of a given numeric property for objects in array.
   * @param array
   * @param propertyName
   */
  public static arrayObjectPropertyMaxValue<T>(array: T[], propertyName: string): number {
    let max: number = 0;
    if (!array || array.length === 0 || !propertyName) {
      return max;
    }
    array.forEach(ele => {
      let value: number = ele[propertyName];
      if (value > max) {
        max = value;
      }
    });
    return max;
  }


  /**
   * Checks if contents of two arrays match.  The values in the arrays
   * do not need to be in the same order.
   * @param array1
   * @param array2
   * @returns
   */
  public static arrayContentsMatch<T>(array1: T[], array2: T[]): boolean {

    if (!array1 && !array2) {
      // Both falsy then match
      return true;
    }

    if ((!array1 && array2) || (array1 && !array2)) {
      // One falsy one truthy then no match
      return false;
    }

    if (array1.length === 0 && array2.length === 0) {
      // Both zero length then match
      return true;
    }

    if (array1.length !== array2.length) {
      // Different array length then no match
      return false;
    }

    if (typeof array1[0] !== typeof array2[0]) {
      // Different data types then no match
      return false;
    }

    // Create an enumerable from the array, sort it, and use sequence equals helper to check if the contents match
    const linq1 = Enumerable.from(array1).orderBy(x => x);
    const linq2 = Enumerable.from(array2).orderBy(x => x);
    return linq1.sequenceEqual(linq2);

  }


  /*http://stackoverflow.com/a/32751487
  function(array, oldIndex, newIndex) {
      if (newIndex >= array.length) {
          newIndex = array.length - 1;
      }
      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
      return array;
  }
  Unit tests:
  describe('ArrayHelper', function () {
      it('Move right', function () {
          let array = [1, 2, 3];
          arrayHelper.move(array, 0, 1);
          assert.equal(array[0], 2);
          assert.equal(array[1], 1);
          assert.equal(array[2], 3);
      })
      it('Move left', function () {
          let array = [1, 2, 3];
          arrayHelper.move(array, 1, 0);
          assert.equal(array[0], 2);
          assert.equal(array[1], 1);
          assert.equal(array[2], 3);
      });
      it('Move out of bounds to the left', function () {
          let array = [1, 2, 3];
          arrayHelper.move(array, 1, -2);
          assert.equal(array[0], 2);
          assert.equal(array[1], 1);
          assert.equal(array[2], 3);
      });
      it('Move out of bounds to the right', function () {
          let array = [1, 2, 3];
          arrayHelper.move(array, 1, 4);
          assert.equal(array[0], 1);
          assert.equal(array[1], 3);
          assert.equal(array[2], 2);
      });
  });
  */

  public static pickListFromOptions(options: { value: string, label?: string }[]): m5core.PickListSelectionViewModel[] {
    return options.map((option, i) => {
      let newPickListSelection = new m5core.PickListSelectionViewModel();
      newPickListSelection.Value = option.value;
      newPickListSelection.DisplayText = option.label || option.value;
      newPickListSelection.DisplayOrder = i;
      return newPickListSelection;
    });
  }

  /**
   * Converts enum into a picklist. The picklist can be used with an ib-input-select when a
   * property type is an enum by setting [optionsPickList] to the value this returns.
   * Logic referenced from: https://tinyurl.com/2p8pxjbm
   * @param enumParam Example: 'm5.SslStartMode'
   * @param valueAsInt if true, the values will be ints, if false, values will be strings (same as label).
   * If this picklist is being used for a property that is an enum type, the user will need to see how the
   * data comes back from the server and set the value type in this picklist to match.
   * @returns m5core.PickListSelectionViewModel[]
   */
  public static pickListFromEnum(enumParam: any, valueAsInt: boolean = true): m5core.PickListSelectionViewModel[] {

    const labels = Object.keys(enumParam).filter((v) => isNaN(Number(v)));
    let values: any[] = [];

    if (valueAsInt) {
      // value will be a number
      values = Object.values(enumParam).filter((v: number) => !isNaN(Number(v)));
    } else {
      // value will be a string (same as label)
      values = Object.values(enumParam).filter((v) => isNaN(Number(v)));
    }

    let tempOptions: { label: string, value: any }[] = [];

    for (let i = 0; i < labels.length; i++) {
      tempOptions.push({
        label: labels[i],
        value: values[i]
      });
    }

    return Helper.pickListFromOptions(tempOptions);
  }

  public static pickListValueModelToSelectionModel(model: m5core.PickListValueEditViewModel): m5core.PickListSelectionViewModel {
    const pickList: m5core.PickListSelectionViewModel = new m5core.PickListSelectionViewModel();
    if (!model) {
      return pickList;
    }
    pickList.PickListId = model.PickListId;
    pickList.DisplayOrder = model.DisplayOrder;
    pickList.GroupText = model.GroupText;
    pickList.DisplayText = Helper.getFirstDefinedString(model.DisplayText, model.Value);
    pickList.Value = Helper.getFirstDefinedString(model.Value, model.DisplayText);
    pickList.Icon = model.Icon;
    pickList.IconColor = model.IconColor;
    pickList.TextColor = model.TextColor;
    pickList.Description = model.DisplayText;
    pickList.Properties = model.Properties;
    pickList.IsDefaultValue = false;
    pickList.IsMutuallyExclusive = model.MutuallyExclusive;
    pickList.PickListValueId = model.PickListValueId;
    pickList.ParentPickListValueId = model.ParentPickListValueId;
    pickList.Children = [];
    if (model.Children && model.Children.length > 0) {
      model.Children.forEach(child => {
        pickList.Children.push(Helper.pickListValueModelToSelectionModel(child));
      });
    }
    return pickList;
  }


  public static pickListDisplayText(value: string, pickList: m5core.PickListSelectionViewModel[]): string {

    if (!value) {
      return "";
    }
    if (!pickList || pickList.length === 0) {
      return value;
    }

    const matches = pickList.filter(x => Helper.equals(x.Value, value, true));
    if (!matches || matches.length === 0) {
      return value;
    }

    return Helper.getFirstDefinedString(matches[0].DisplayText, value);

  }


  /**
   * Converts a picklist selection array to an array with grouping information used by our multi-select control.
   * @see http://isteven.github.io/angular-multi-select
   * @param pickList
   * @returns array obj objects that look like PickListSelectionViewModel but with group wrapper objects
   */
  public static pickListToMultiSelectArray(pickList: m5core.PickListSelectionViewModel[]): any[] {

    if (!pickList || pickList.length === 0) {
      return [];
    }

    // Breaks horribly with groups so until there is time to sort that out just disable grouping
    // when there are multiple pick lists with groups they all seem to update each other even
    // when the lists are different copies of the list.  Bad news so just drop it for now.
    // TODO figure out why
    //return Helper.deepCopy(pickList);

    var linq = Enumerable.from(pickList);

    // If we don't have any group text then our multi-select array is the same as our pick list
    // but return a copy of the list since it may be reused and this gets modified for by the
    // multi-select component so we need a clean copy not a reference to an existing copy.
    if (!linq.any(x => x.GroupText && x.GroupText !== "")) {
      return Helper.deepCopy(pickList);
    }

    // Now figure out if we have a display order to respect
    var ordered: boolean = linq.any(x => x.DisplayOrder && x.DisplayOrder > 0);

    // Sort
    var sorted: m5core.PickListSelectionViewModel[];
    if (ordered) {
      sorted = linq.orderBy(x => x.GroupText).thenBy(x => x.DisplayOrder).thenBy(x => x.DisplayText).toArray();
    } else {
      sorted = linq.orderBy(x => x.GroupText).thenBy(x => x.DisplayText).toArray();
    }

    // Build our output array
    var output: any[] = [];
    var lastGroup: string = "!@#$%^&*()";
    var openGrouping: boolean = false;
    sorted.forEach((item, index, items) => {
      if (item.GroupText !== lastGroup && output.length > 0) {
        // New group and we have items in our list so mark the end of the group
        output.push({ Group: false });
        openGrouping = false;
      }
      if (item.GroupText !== lastGroup) {
        // New group so mark the beginning of the group
        output.push({ DisplayText: `<strong>${item.GroupText}</strong>`, Value: `<strong>${item.GroupText}</strong>`, Group: true });
        openGrouping = true;
        lastGroup = item.GroupText;
      }
      // Add our item
      output.push(Helper.deepCopy(item));
    });
    // Close out any open grouping
    if (openGrouping && output.length > 0) {
      output.push({ Group: false });
    }

    return output;

  }


  /**
   * This helper method will make sure the provided model object has the following properties
   * initialized for use: model.MetaData, model.MetaData.DeletedDataObjects, model.MetaData.Properties.
   * @param {any} model - The model object that should have MetaData prepared.  If falsy no action is taken.
   */
  public static prepareMetaData(model: any): void {
    if (!model) {
      return;
    }
    if (!model.MetaData) {
      model.MetaData = new m.MetaDataModel();
    }
    if (!model.MetaData.DeletedDataObjects) {
      model.MetaData.DeletedDataObjects = [];
    }
    if (!model.MetaData.Properties) {
      model.MetaData.Properties = {};
    }
  }


  //interface String {
  //  startsWith(str: string): boolean;
  //}
  //if (typeof String.prototype.startsWith !== "function") {
  //  String.prototype.startsWith = function (str: string) {
  //    return this.indexOf(str) === 0;
  //  };
  //}




  //function float2int(value) {
  //  return value | 0;
  //}


  //function IsInteger(n) { return parseInt(n) === n };


  //function utcOffsetFloat2String(utc: number, includeMinuteSeparator: boolean = true): string {
  //  if (!utc || utc == 0) {
  //    return "+0000";
  //  }
  //  var offset = utc.toString();
  //  if (IsInteger(utc)) {
  //    if (!offset.startsWith("-")) {
  //      offset = "+" + offset;
  //    }
  //    if (offset.length === 2) {
  //      offset = offset.substr(0, 1) + "0" + offset.substr(1, 1);
  //    }
  //  } else {
  //    var float = utc - float2int(utc);
  //    offset = float2int(utc).toString();
  //    if (!offset.startsWith("-")) {
  //      offset = "+" + offset;
  //    }
  //    if (offset.length === 2) {
  //      offset = offset.substr(0, 1) + "0" + offset.substr(1, 1);
  //    }
  //    offset = offset + (includeMinuteSeparator ? ":" : "") + Helper.PadString('00', float2int((float * 60)).toString(), true);
  //  }
  //  return offset;
  //}


  /**
   * Prepares a url by prefixing text if the url doesn't already begin with specified text.
   * For example, if url doesn't start with http then prefix http:// to the url.
   * @param url
   * @param whenPreparedStartsWith
   * @param whenNotPreparedPrefixThis
   */
  public static prepareUrl(url: string, whenPreparedStartsWith: string = "http", whenNotPreparedPrefixThis: string = "http://"): string {
    try {
      if (!url) {
        return url;
      }
      if (!url.startsWith(whenPreparedStartsWith)) {
        url = whenNotPreparedPrefixThis + url;
      }
      return url;
    } catch (err) {
      Log.errorMessage(err);
      return url;
    }
  }


  /**
   * Checks if single character is considered a word-break character.
   * @param value A single character
   * @returns
   */
  public static isWordBreakCharacter(value: string): boolean {
    if (!value) {
      value = "";
    }
    if (value.length > 1) {
      value = value.charAt(value.length - 1)
    }
    return Helper.contains(" !:;,.?\t\n", value, false);
  }


  /**
   * Get the last word from the specified string removing any trailing word-break character.
   * @param value The string to return the last word from.
   * @returns
   */
  public static lastWord(value: string): string {

    // Get the last word
    let lastWord: string = value.toString().trim().split(" ").filter(x => x).pop();

    // See if the last "character" is &nbsp; since value could be html, and remove it
    if (Helper.endsWith(lastWord, "&nbsp;", true)) {
      lastWord = lastWord.substring(0, lastWord.length - 6);
    }

    // See if the last character is punctuation and, if so, remove it
    if (lastWord && Helper.isWordBreakCharacter(lastWord.charAt(lastWord.length - 1))) {
      lastWord = lastWord.substring(0, lastWord.length - 1);
    }

    return lastWord;

  }




  /**
  Checks if a string equals a specific value ignoring case.
  @param {string} str The string to check.
  @param {string} prefix The string to check for.
  @param {boolean} ignoreCase When true will ignore case when checking
  @returns {boolean} True if str contains the value.
  */
  public static equals(str: string, value: string, ignoreCase?: boolean): boolean {
    try {
      if (!str && !value) {
        // Both falsy then equals
        return true;
      } else if ((!str && value) || (str && !value)) {
        // One falsy and one not then not equals
        return false;
      }
      if (typeof str !== "string") {
        str = (<any>str).toString();
      }
      if (typeof value !== "string") {
        value = (<any>value).toString();
      }
      if (ignoreCase) {
        return (str.toUpperCase() === value.toUpperCase());
      }
      return (str === value);
    } catch (err) {
      Log.errorMessage(err);
      return false;
    }
  }

  public static containsSomeAlpha(str: string): boolean {
    if (str.match(/[a-z]/i)) {
      return true;
    }
    return false;
  }

  public static containsSomeAlphaUpper(str: string): boolean {
    if (str.match(/[A-Z]/)) {
      return true;
    }
    return false;
  }

  public static containsSomeAlphaLower(str: string): boolean {
    if (str.match(/[a-z]/)) {
      return true;
    }
    return false;
  }

  public static containsSomeNumber(str: string): boolean {
    if (str.match(/\d/)) {
      return true;
    }
    return false;
  }

  public static containsSomeSpecialCharacters(str: string): boolean {
    if (str.match(/[ _.,!"'/$@#%^&*()-\+=<>?`~]/)) {
      return true;
    }
    return false;
  }

  /**
  Checks if a string contains a specific value.
  @param {string} str The string to check.
  @param {string} value The string to check for.
  @param {boolean} ignoreCase When true will ignore case when checking
  @returns {boolean} True if str contains the value.
  */
  public static contains(str: string, value: string, ignoreCase?: boolean): boolean {
    // Both falsy then true?
    if (!str && !value) {
      return true;
    }
    // One falsy and one not then can't be true
    if ((!str && value) || (str && !value)) {
      return false;
    }
    try {
      if (ignoreCase) {
        return (str.toUpperCase().indexOf(value.toUpperCase()) !== -1);
      }
      return (str.indexOf(value) !== -1);
    } catch (err) {
      Log.errorMessage(err);
      return false;
    }
  }

  /**
  Checks if a string starts with a specific value.
  @param {string} str The string to check.
  @param {string} prefix The string to check for.
  @param {boolean} ignoreCase When true will ignore case when checking
  @returns {boolean} True if str starts with prefix.
  */
  public static startsWith(str: string, prefix: string, ignoreCase?: boolean): boolean {
    // Both falsy then true?
    if (!str && !prefix) {
      return true;
    }
    // One falsy and one not then can't be true
    if ((!str && prefix) || (str && !prefix)) {
      return false;
    }
    if (ignoreCase) {
      return (str.slice(0, prefix.length).toUpperCase() === prefix.toUpperCase());
    }
    return (str.slice(0, prefix.length) === prefix);
  }

  /**
  Checks if a string ends with a specific value.
  @param {string} str The string to check.
  @param {string} suffix The string to check for.
  @param {boolean} ignoreCase When true will ignore case when checking
  @returns {boolean} True if str ends with suffix.
  */
  public static endsWith(str: string, suffix: string, ignoreCase?: boolean): boolean {
    // Both falsy then true?
    if (!str && !suffix) {
      return true;
    }
    // One falsy and one not then can't be true
    if ((!str && suffix) || (str && !suffix)) {
      return false;
    }
    if (ignoreCase) {
      return str.toUpperCase().indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1;
    }
    //return (suffix === "" || str.slice(-suffix.length) === suffix);
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  public static insertAt(str: string, index: number, insert: string) {
    return str.substr(0, index) + insert + str.substr(index);
  }

  public static streetAddressNormalizeExpanded(street: string): string {
    if (Helper.endsWith(street, " Dr")) {
      street = street.replace(" Dr", " Drive");
    } else if (Helper.endsWith(street, " Dr.")) {
      street = street.replace(" Dr.", " Drive");
    } else if (Helper.endsWith(street, " Dr N")) {
      street = street.replace(" Dr N", " Drive North");
    } else if (Helper.endsWith(street, " Dr S")) {
      street = street.replace(" Dr S", " Drive South");
    } else if (Helper.endsWith(street, " Dr E")) {
      street = street.replace(" Dr E", " Drive East");
    } else if (Helper.endsWith(street, " Dr W")) {
      street = street.replace(" Dr W", " Drive West");
    } else if (Helper.endsWith(street, " Rd")) {
      street = street.replace(" Rd", " Road");
    } else if (Helper.endsWith(street, " Rd.")) {
      street = street.replace(" Rd.", " Road");
    } else if (Helper.endsWith(street, " St")) {
      street = street.replace(" St", " Street");
    } else if (Helper.endsWith(street, " St.")) {
      street = street.replace(" St.", " Street");
    } else if (Helper.endsWith(street, " Ave")) {
      street = street.replace(" Ave", " Avenue");
    } else if (Helper.endsWith(street, " Ave.")) {
      street = street.replace(" Ave.", " Avenue");
    } else if (Helper.endsWith(street, " Ct")) {
      street = street.replace(" Ct", " Court");
    } else if (Helper.endsWith(street, " Ct.")) {
      street = street.replace(" Ct.", " Court");
    }
    return street;
  }



  // Local ip address support was more trouble than it was worth
  ///**
  // * List of local ip addresses if any were discoverable.
  // */
  //public static localIpAddressList: string[] = [];
  ///**
  // * Builds our list of local ip addresses if any were discoverable.
  // * This should be called on app start so the list is prebuilt or in a timeout since the
  // * list is populated async.
  // * see http://stackoverflow.com/a/32841164
  // * @returns {}
  // */
  //public static buildLocalIpAddressList(): string[] {
  //  if (Helper.localIpAddressList && Helper.localIpAddressList.length > 0) {
  //    return Helper.localIpAddressList;
  //  }
  //  try {
  //    let win: any = window;
  //    let myPeerConnection = win.RTCPeerConnection || win.mozRTCPeerConnection || win.webkitRTCPeerConnection; //compatibility for firefox and chrome
  //    let pc = new myPeerConnection({ iceServers: [] }),
  //      noop = function () { },
  //      localIPs = {},
  //      ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
  //      key;
  //    let ipIterate = function (ip) {
  //      if (!localIPs[ip]) {
  //        Helper.localIpAddressList.push(ip);
  //      }
  //      localIPs[ip] = true;
  //    }
  //    pc.createDataChannel(""); //create a bogus data channel
  //    pc.createOffer(function (sdp) {
  //      sdp.sdp.split('\n').forEach(function (line) {
  //        if (line.indexOf('candidate') < 0) return;
  //        line.match(ipRegex).forEach(ipIterate);
  //      });
  //      pc.setLocalDescription(sdp, noop, noop);
  //    }, noop); // create offer and set local description
  //    pc.onicecandidate = function (ice) { //listen for candidate events
  //      if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
  //      ice.candidate.candidate.match(ipRegex).forEach(ipIterate);
  //    };
  //  } catch (err) {
  //    // Don't bother reporting an expected error when we're using IE or Edge
  //    if (!Helper.isBrowserIeOrEdge()) {
  //      console.error("Error while trying to build list of local ip addresses.");
  //      console.error(err);
  //    }
  //    // Push in a place holder local ip address so we don't keep retrying
  //    Helper.localIpAddressList.push("127.0.0.1");
  //  }
  //  return Helper.localIpAddressList;
  //}



  /**
   * Get display order to apply to a new object of the specified type.
   *
   * @param list                   Array of objects that a new object will be part of we inspect this list to find the current highest display order.
   * @param displayOrderAccessor   Function that returns the display order property from the specified object type.
   * @param defaultIncrement       The number to increment the display order by.  Defaults to 1.
   *
   * @example
   * let newDisplayOrder: number = Helper.getDisplayOrder( items , x => x.DisplayOrder );
   * let newDisplayOrder: number = Helper.getDisplayOrder( items , x => x.DisplayOrder , 100 );
   */
  public static displayOrderGet<TObject>(list: TObject[], displayOrderAccessor: (x: TObject) => number, defaultIncrement: number = 1): number {
    if (!defaultIncrement || defaultIncrement < 1) {
      defaultIncrement = 1;
    }
    if (!list || list.length === 0) {
      return defaultIncrement;
    }
    try {
      let max: number = Enumerable.from<TObject>(list).max(displayOrderAccessor);
      return ((max || 0) + defaultIncrement);
    } catch (error) {
      Log.errorMessage(error);
      return defaultIncrement;
    }
  }

  public static displayOrderMoveTop(list: any[], index: number, displayOrderPropertyName: string = ""): void {
    if (!list || list.length === 0) {
      return;
    }
    if (!index) {
      // Index 0 already at top of list
      return;
    }
    if (index < 0 || index > list.length - 1) {
      Log.errorMessage(`Index ${index} points to an object that does not exist in the list and, therefore, the display order will not be updated.`);
      return;
    }
    try {
      if (displayOrderPropertyName) {
        // Get display order value first in list and increment all others
        var targetItemDisplayOrder: number = list[0][displayOrderPropertyName] || 1;
        list.forEach((item: any, pos: number, items: any[]) => {
          item[displayOrderPropertyName] = (item[displayOrderPropertyName] || 1) + 1;
        });
        list[index][displayOrderPropertyName] = targetItemDisplayOrder;
      }
      // Swap array positions
      Helper.arrayElementMove(list, index, 0);
      return;
    } catch (error) {
      Log.errorMessage(error);
      return;
    }
  }

  public static displayOrderMoveUp(list: any[], index: number, displayOrderPropertyName: string = ""): void {
    if (!list || list.length === 0) {
      return;
    }
    if (!index) {
      // Index 0 already at top of list
      return;
    }
    if (index < 0 || index > list.length - 1) {
      Log.errorMessage(`Index ${index} points to an object that does not exist in the list and, therefore, the display order will not be updated.`);
      return;
    }
    try {
      if (displayOrderPropertyName) {
        // Swap display order values
        var currentItemDisplayOrder: number = list[index][displayOrderPropertyName] || 1;
        var targetItemDisplayOrder: number = list[index - 1][displayOrderPropertyName] || 1;
        list[index][displayOrderPropertyName] = targetItemDisplayOrder;
        list[index - 1][displayOrderPropertyName] = currentItemDisplayOrder;
      }
      // Swap array positions
      Helper.arrayElementMove(list, index, index - 1);
      return;
    } catch (error) {
      Log.errorMessage(error);
      return;
    }
  }

  public static displayOrderMoveDown(list: any[], index: number, displayOrderPropertyName: string = ""): void {
    if (!list || list.length === 0) {
      return;
    }
    if (index === (list.length - 1)) {
      // Index already at bottom of list
      return;
    }
    if (index < 0 || index > list.length - 1) {
      Log.errorMessage(`Index ${index} points to an object that does not exist in the list and, therefore, the display order will not be updated.`);
      return;
    }
    try {
      if (displayOrderPropertyName) {
        // Swap display order values
        var currentItemDisplayOrder: number = list[index][displayOrderPropertyName] || 1;
        var targetItemDisplayOrder: number = list[index + 1][displayOrderPropertyName] || 1;
        list[index][displayOrderPropertyName] = targetItemDisplayOrder;
        list[index + 1][displayOrderPropertyName] = currentItemDisplayOrder;
      }
      // Swap array positions
      Helper.arrayElementMove(list, index, index + 1);
      return;
    } catch (error) {
      Log.errorMessage(error);
      return;
    }
  }

  public static displayOrderMoveBottom(list: any[], index: number, displayOrderPropertyName: string = ""): void {
    if (!list || list.length === 0) {
      return;
    }
    if (index === (list.length - 1)) {
      // Index already at bottom of list
      return;
    }
    if (index < 0 || index > list.length - 1) {
      Log.errorMessage(`Index ${index} points to an object that does not exist in the list and, therefore, the display order will not be updated.`);
      return;
    }
    try {
      if (displayOrderPropertyName) {
        // Get display order value last in list
        var targetItemDisplayOrder: number = list[list.length - 1][displayOrderPropertyName] || 1;
        list[index][displayOrderPropertyName] = (targetItemDisplayOrder + 1);
      }
      // Swap array positions
      Helper.arrayElementMove(list, index, Constants.Numbers.MaxInt32);
      return;
    } catch (error) {
      Log.errorMessage(error);
      return;
    }
  }


  /**
   * Type-safe access of deep property of an object
   *
   * @param obj                   Object to get deep property
   * @param unsafeDataOperation   Function that returns the deep property
   * @param valueIfFail           Value to return in case if there is no such property
   * @param valueIfFalsy          Value to return in case if the property is there but it's falsy
   *
   * @example
   * Helper.tryGetValue( foo , x => x.bar.check , true );
   * Helper.tryGetValue( foo , x => x.bar.description , "The Bar" );
   */
  public static tryGetValue<TObject, TValue>(obj: TObject, unsafeDataOperation: (x: TObject) => TValue, valueIfFail?: any, valueIfFalsy?: any): TValue {
    try {
      let value = unsafeDataOperation(obj);
      if (!value && valueIfFalsy !== undefined) {
        return valueIfFalsy;
      } else {
        return value;
      }
    } catch (error) {
      return valueIfFail;
    }
  }


  /**
  Returns the first not empty/null/undefined string in the list of parameters.  This can be used to
  provide a list of items in order of preference and get back the one that is not falsy.
  */
  public static getFirstDefinedString(...values: string[]): string {
    let value = "";
    values.forEach((input: string, index: number, array: string[]) => {
      if (!value && input) {
        value = input;
      }
    });
    return value;
  }


  /**
  Returns the first not empty/null/undefined string from object using list of property names.  This can be used to
  provide a list of items in order of preference and get back the one that is not falsy.
  */
  public static getFirstDefinedStringFromProperties(obj: any, ...propertyNames: string[]): string {
    return Helper.getFirstDefinedStringFromPropertyNameList(obj, propertyNames);
  }
  public static getFirstDefinedStringFromPropertyNameList(obj: any, propertyNames: string[]): string {
    let value = "";
    if (!obj) {
      return value;
    }
    propertyNames.forEach((propertyName: string, index: number, array: string[]) => {
      if (!value && obj[propertyName]) {
        //console.error(propertyName, obj[propertyName], Helper.type(obj[propertyName]));
        if (obj[propertyName] instanceof Date || Helper.endsWith(propertyName, "DateTime", true)) {
          value = Helper.formatDateTime(obj[propertyName], "MMM d, yyyy, h:mm:ss aaa");
        } else if (Helper.endsWith(propertyName, "Date", true)) {
          value = Helper.formatDateTime(obj[propertyName], "MMM d, yyyy");
        } else {
          value = obj[propertyName];
        }
      }
    });
    return value;
  }


  /**
  Returns the first not empty/null/undefined value in the list of parameters.  This can be used to
  provide a list of items in order of preference and get back the one that is not falsy.  For
  example, an undefined date, "not set", etc.
  */
  public static getFirstValue(maxLength: number, format: string, ...values: any[]): string {
    let value = "";
    values.forEach((input: any, index: number, array: any[]) => {
      if (!value && input) {
        if (input instanceof Date && format) {
          value = Helper.formatDateTime(input, format);
        } else {
          value = input.toString();
        }
        if (maxLength && value.length > maxLength) {
          value = value.substring(0, maxLength - 3) + "...";
        }
      }
    });
    return value;
  }


  /**
   * Perform string formatting to replace property names wrapped in {} or {{}} with values from an object with that property name.
   * @example var filter = Helper.stringFormat( 'CustomerName = "{CustomerName}" && Address1 = "{Address1}" && Address2 = "{Address2}" && City = "{City}"' , contact );
   * @param input String containing markup to parse the inputArgs into
   * @param inputArgs Class or variable containing data to be inserted into the input string
   * @returns {}
   */
  public static stringFormat(input: string, inputArgs: any, urlEncode: boolean = false, urlSlugEncode: boolean = false): string {
    let str = input;
    for (const arg in inputArgs) {
      if (urlSlugEncode) {
        str = str.replace(RegExp("\\{\\{" + arg + "\\}\\}", "gi"), Helper.encodeURISlug(inputArgs[arg]));
        str = str.replace(RegExp("\\{" + arg + "\\}", "gi"), Helper.encodeURISlug(inputArgs[arg]));
      } else if (urlEncode) {
        str = str.replace(RegExp("\\{\\{" + arg + "\\}\\}", "gi"), encodeURIComponent(inputArgs[arg]));
        str = str.replace(RegExp("\\{" + arg + "\\}", "gi"), encodeURIComponent(inputArgs[arg]));
      } else {
        str = str.replace(RegExp("\\{\\{" + arg + "\\}\\}", "gi"), inputArgs[arg]);
        str = str.replace(RegExp("\\{" + arg + "\\}", "gi"), inputArgs[arg]);
      }
    }
    return str;
  }



  ///**
  //Handles angular hash tagging of a path.
  //@deprecated
  //*/
  //public static getPath(path: string): string {
  //  if (path.substr(0, 1) === '#') {
  //    // Already has hash-bang prefix
  //  }
  //  else if (path.substr(0, 1) === '/') {
  //    path = "#!" + path;
  //  }
  //  else {
  //    path = "#!/" + path;
  //  }
  //  return path;
  //}


  ///**
  //Handles assigning path.
  //@deprecated
  //*/
  //public static SetPath(path: string, $location: ng.ILocationService): void {
  //  path = Helper.GetPath(path);
  //  // $location causing some redirect loop problems so drop $location
  //  // support even when that means no html5 url support but hash-bang
  //  // url is better than these redirect loop problems.
  //  //if (false) { //$location) {
  //  //    //console.log('$location = ' + path);
  //  //    $location.path(path);
  //  //}
  //  //else {
  //  //    //console.log('location.href = ' + path);
  //  //    location.href = path;
  //  //}
  //  location.href = path;
  //}


  /**
  Checks if the specified path is part of the current path.  Can be used for tagging classes on menus, etc. to give visual context to the current page.
  @param {string} path The part of the path to check.
  @returns {boolean} Returns true if the specified path is part of the current path.
  */
  public static pathContains(path: string): boolean {
    path = path.toLowerCase();
    return (location.href.toLowerCase().indexOf(path) > -1);
  }


  public static getQueryStringParameter(name: string, url: string = null) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }


  /**
  Encodes the url or part of the url.
  @param {string} part The part of the url to encode.
  @returns {string} Encoded url.
  */
  public static encodeURIPart(part: string): string {
    return encodeURIComponent(part).replace(".", "%2E");
  }

  /**
  Encodes the text to be used as url slug.
  @param {string} text The part of the url to encode.
  @returns {string} Encoded url.
  */
  public static encodeURISlug(text: string): string {
    if (!text) {
      return "";
    }
    text = text.toString();
    try {
      text = Helper.replaceAll(text, "'", "");
      text = Helper.replaceAll(text, '"', "");
      text = Helper.replaceAll(text, " ", "-");
      text = Helper.replaceAll(text, "*", "-");
      text = Helper.replaceAll(text, "+", "-");
      text = Helper.replaceAll(text, "<", "-");
      text = Helper.replaceAll(text, ">", "-");
      text = Helper.replaceAll(text, "/", "-");
      text = Helper.replaceAll(text, "\\", "-");
      text = Helper.replaceAll(text, "\?", "-");
      text = Helper.replaceAll(text, "&", "-");
      text = Helper.replaceAll(text, ",", "-");
      text = Helper.replaceAll(text, "\.", "-");
      text = Helper.replaceAll(text, "!", "-");
      text = Helper.replaceAll(text, ";", "-");
      text = Helper.replaceAll(text, "\:", "-");
      text = Helper.replaceAll(text, "\=", "-");
      text = Helper.replaceAll(text, "#", "-");
      text = Helper.replaceAll(text, "$", "-");
      text = Helper.replaceAll(text, "@", "-");
      text = Helper.replaceAll(text, "(", "-");
      text = Helper.replaceAll(text, ")", "-");
      text = Helper.replaceAll(text, "{", "-");
      text = Helper.replaceAll(text, "}", "-");
      text = Helper.replaceAll(text, "[", "-");
      text = Helper.replaceAll(text, "]", "-");
      text = Helper.replaceAll(text, "----", "-");
      text = Helper.replaceAll(text, "---", "-");
      text = Helper.replaceAll(text, "--", "-");
      text = Helper.left(text, 75);
      if (Helper.right(text, 1) === "-" && text.length > 1) {
        text = Helper.left(text, text.length - 1);
      }
      if (Helper.left(text, 1) === "-" && text.length > 1) {
        text = text.substring(1);
      }
    } catch (err) {
      Log.errorMessage(err);
    }
    return text.toLowerCase();
  }


  ///**
  //Gets the angular injector in case you were too lazy to inject all of your needed objects.
  //@returns {any} The angular injector.
  //*/
  //public static GetInjector(): any {
  //  var element = document.querySelector('.ng-scope');
  //  return angular.element(element).injector();
  //}


  /**
  Determines if the specified item is an array.
  @param {any} data The data to check.
  @returns {boolean} True if data is an array.
  */
  public static isArray(data: any): boolean {
    if (!data) {
      return false;
    }
    if (Array.isArray) {
      return Array.isArray(data);
    }
    //return (!!data) && (data.constructor === Array);
    return (data.constructor === Array);
  }


  /**
   * Array of specified length.  We use this in interesting ways like place holder columns in a table footer:
   * <th ng-repeat="i in $ctrl.coreHelper.newArray($ctrl.options.columns.length-2) track by $index"></th>
   * @param length
   */
  public static newArray<T>(length: number): Array<T> {
    if (!length || length < 0) {
      length = 0;
    }
    return new Array(length);
  }


  public static sessionStorageDelete(key: string): void {
    delete window.sessionStorage[key];
  }

  public static sessionStorageSave(key: string, value: any): void {
    window.sessionStorage[key] = value;
  }

  public static sessionStorageGet(key: string, defaultValue: any): any {
    return window.sessionStorage[key] || defaultValue;
  }

  public static sessionStorageSaveObject<T>(key: string, value: T): void {
    window.sessionStorage[key] = JSON.stringify(value);
  }

  public static sessionStorageGetObject<T>(key: string, defaultValue: T): T {
    try {
      const json = window.sessionStorage[key];
      if (!json) {
        return defaultValue;
      }
      return (JSON.parse(window.sessionStorage[key]) || defaultValue);
    } catch (err) {
      Log.errorMessage(err);
      Log.errorMessage(window.sessionStorage[key]);
      return defaultValue;
    }
  }

  public static localStorageDelete(key: string): void {
    delete window.localStorage[key];
  }

  public static localStorageSave(key: string, value: any): void {
    window.localStorage[key] = value;
  }

  public static localStorageGet(key: string, defaultValue: any): any {
    return window.localStorage[key] || defaultValue;
  }

  public static localStorageSaveObject<T>(key: string, value: T): void {
    window.localStorage[key] = JSON.stringify(value);
  }

  public static localStorageGetObject<T>(key: string, defaultValue: T): T {
    try {
      const json = window.localStorage[key];
      if (!json) {
        return defaultValue;
      }
      return (JSON.parse(window.localStorage[key]) || defaultValue);
    } catch (err) {
      Log.errorMessage(err);
      Log.errorMessage(window.localStorage[key]);
      return defaultValue;
    }
  }



  public static enumGetNames(e: any): string[] {
    return Object.keys(e).filter(k =>
      typeof e[k] === "number"
      || e[k] === k
      || e[e[k]]?.toString() !== k
    );
  }



  /**
   * If source has properties assigned to it the values of those properties will be assigned to
   * properties of the same name in the target.  Find references for examples of use.
   * @param source
   * @param target
   */
  public static objectUpdateProperties(source: any, target: any) {

    if (source === null || source === undefined) {
      return;
    }

    let sourceProperties: string[] = Helper.objectGetPropertyNameList(source);
    if (sourceProperties && sourceProperties.length > 0) {
      if (target === null || target === undefined) {
        target = {};
      }
      let targetProperties: string[] = Helper.objectGetPropertyNameList(target);
      sourceProperties.forEach((propertyName) => {
        if (targetProperties.indexOf(propertyName) > -1) {
          target[propertyName] = source[propertyName];
        } else {
          Helper.objectDefineProperty(target, propertyName, source[propertyName]);
        }
      });
    }

  }


  //public static objectUpdateDeep<T>(source: T, target: T) {

  //  if (!source) {
  //    return;
  //  }

  //  Object.keys(source).forEach((key) => {

  //    //// delete property if set to undefined or null
  //    //if (undefined === source[key] || null === source[key]) {
  //    //  delete target[key]
  //    //}

  //    // property value is object, so recurse
  //    if ('object' === typeof source[key] && !Array.isArray(source[key])) {

  //      // target property not object, overwrite with empty object
  //      if (!('object' === typeof target[key] && !Array.isArray(target[key]))) {
  //        target[key] = {}
  //      }

  //      // recurse
  //      Helper.objectUpdateDeep(source[key], target[key]);
  //    }

  //    // set target property to update property
  //    else {
  //      target[key] = source[key]
  //    }
  //  });

  //}


  public static objectDefineProperty(obj, key, value) {
    let config = {
      value: value,
      writable: true,
      enumerable: true,
      configurable: true
    };
    Object.defineProperty(obj, key, config);
  }


  /**
   * Determine if object has all of the specified property names.  This can be used as a
   * test of probability that the object is of a specified type.
   * @param obj
   * @param propertyNames
   */
  public static objectHasProperties(obj: any, ...propertyNames: string[]): boolean {

    if (!obj) {
      return false;
    }

    // Consider us a match until we're not since we have more than one property name to check
    let found: boolean = true;

    propertyNames.forEach((propertyName) => {
      if (!obj.hasOwnProperty(propertyName)) {
        //We can return false at the first time a property is not found
        found = false;
      }
    });

    return found;

  }


  /**
   * Determine if object only has the specified property names.
   * @param obj
   * @param propertyNames
   */
  public static objectHasOnlyProperties(obj: any, ...propertyNames: string[]): boolean {

    if (!obj || !propertyNames) {
      return false;
    }

    // Get list of properties on object
    const existingPropertyNames: string[] = Helper.objectGetPropertyNameList(obj);

    // Check if the two arrays have the same contents
    return Helper.arrayContentsMatch(existingPropertyNames, propertyNames);

  }



  /**
  Gets list of property names on object.
  @param {any} data The data to check.
  @returns {string[]} List of property names on object.
  */
  public static objectGetPropertyNameList(data: any): string[] {

    if (data === null || data === undefined) {
      return [];
    }

    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    //for (var key in data) {
    //    if (Object.prototype.hasOwnProperty.call(data, key)) return false;
    //}
    // If you only need to handle ECMAScript5 browsers, you can use Object.getOwnPropertyNames instead of the hasOwnProperty loop:
    try {
      return Object.getOwnPropertyNames(data);
    } catch (err) {
      try {
        const list: string[] = [];
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            list.push(key);
          }
        }
      } catch (err) {
        Log.errorMessage(err);
      }
    }

    return [];

  }


  /*
   * return a copy of an object with only non-object keys
   * we need this to avoid circular references
   */
  public static objectKeepSimpleKeys(original) {
    const simple: any = Object.keys(original).reduce(function (obj, key) {
      obj[key] = (Helper.contains(typeof original[key], 'object', true) ? '{ ... }' : original[key]);
      return obj;
    }, {});
    return simple;
  }


  public static objectEquals<T>(object1: T, object2: T, propertiesToIgnore: string[] = [], depth: number = 100000, keysOnly: boolean = false, valuesOnly: boolean = false, currentDepth: number = 0): boolean {
    if (!object1 || !object2 || typeof object1 !== 'object' || typeof object2 !== 'object') {
      return (object1 === object2);
    }
    if (currentDepth >= depth) {
      return true;
    }
    currentDepth += 1;
    try {
      const entries1 = Object.entries(object1);
      const entries2 = Object.entries(object2);
      if (entries1.length !== entries2.length) {
        return false;
      }
      for (let index = 0; index < entries1.length; index += 1) {
        let ignore: boolean = false;
        if (propertiesToIgnore && propertiesToIgnore.length > 0 && propertiesToIgnore.includes(entries1[index][0])) {
          ignore = true;
          //console.error("ignore", entries1[index][0]);
        }
        if (!ignore) {
          if (entries1[index][0] !== entries2[index][0] && !valuesOnly) {
            return false;
          }
          const valueComparison = Helper.objectEquals(entries1[index][1], entries2[index][1], propertiesToIgnore, depth, keysOnly, valuesOnly, currentDepth);
          if (!valueComparison && !keysOnly) {
            return false;
          }
        }
      }
      return true;
    } catch (err) {
      Log.errorMessage(err);
      return false;
    }
  }



  /**
   * Compares original object and modified object and returns a difference object that includes
   * only the properties in modified obj that have been modified.  Will also include any properties
   * in the alwaysIncludeProperties array which can be used to make sure key properties like id values
   * will be part of the resulting object.
   * @param original
   * @param modified
   * @param alwaysIncludeProperties
   */
  public static objectDiff<T>(original: T, modified: T, ...alwaysIncludeProperties: string[]): any {
    return Helper.objectMergeDiff(original, modified, alwaysIncludeProperties, []);
  }



  /**
   * Compares original object and modified object and returns a difference object that includes
   * only the properties in modified obj that have been modified.  Will also include any properties
   * in the alwaysIncludeProperties array which can be used to make sure key properties like id values
   * will be part of the resulting object.  Any properties in alwaysExcludeProperties will never be
   * included in the diff even if they differ.
   * @param original
   * @param modified
   * @param alwaysIncludeProperties
   * @param alwaysExcludeProperties
   */
  public static objectMergeDiff<T>(original: T, modified: T, alwaysIncludeProperties: string[] = [], alwaysExcludeProperties: string[] = []): any {

    const diff: any = {};

    for (let p in original) {

      let include: boolean = false;
      if (alwaysIncludeProperties && alwaysIncludeProperties.length > 0 && alwaysIncludeProperties.includes(p)) {
        include = true;
      }

      let exclude: boolean = false;
      if (alwaysExcludeProperties && alwaysExcludeProperties.length > 0 && alwaysExcludeProperties.includes(p)) {
        exclude = true;
      }

      if (!exclude) {
        if (include || !Helper.objectEquals(original[p], modified[p])) {
          diff[p] = modified[p];
        }
      }

    }

    return diff;

  }



  /**
  Determines if the specified item is an object.
  @param {any} data The data to check.
  @returns {boolean} True if data is an object.
  */
  public static isObject(data: any): boolean {
    return data === Object(data);
  }




  public static type(obj) {
    const checker = {};
    const types = "Boolean Number String Function Array Date RegExp Object".split(" ");
    for (const i in types) {
      checker["[object " + types[i] + "]"] = types[i].toLowerCase();
    }
    return obj === null ?
      String(obj) :
      checker[Object.prototype.toString.call(obj)] || "object";
  }

  public static isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  public static isUndefinedOrNull(value) {
    if (value === undefined || value === null) {
      return true;
    }
    return false;
  }

  public static isString(str) {
    if (str === undefined || str === null) {
      return false;
    }
    if (typeof str === "string") {
      return true;
    }
    if (typeof str === "object" && str.constructor === String) {
      return true;
    }
    return false;
  }

  public static isFunction(obj) {
    return Helper.type(obj) === "function";
  }
  public static isWindow(obj) {
    return obj !== null && obj === obj.window;
  }
  public static isPlainObject(obj) {
    const hasOwn = Object.prototype.hasOwnProperty;
    // Must be an Object.
    // Because of IE, we also have to check the presence of the constructor property.
    // Make sure that DOM nodes and window objects don't pass through, as well
    if (!obj || Helper.type(obj) !== "object" || obj.nodeType || Helper.isWindow(obj)) {
      return false;
    }

    try {
      // Not own constructor property must be Object
      if (obj.constructor &&
        !hasOwn.call(obj, "constructor") &&
        !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
        return false;
      }
    } catch (e) {
      // IE8,9 Will throw exceptions on certain host objects #9897
      return false;
    }

    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    let key;
    for (key in obj) { }
    return key === undefined || hasOwn.call(obj, key);
  }

  public static isArray2(obj) {
    return Helper.type(obj) === "array";
  }

  public static firstOrDefault<T>(input: T[], callbackfn: (value: T, index: number, array: T[]) => any, defaultValue: T = null): T {
    if (!input || input.length === 0) {
      return defaultValue;
    }
    const values: T[] = input.filter(callbackfn);
    if (!values || values.length === 0) {
      return defaultValue;
    }
    return values[0];
  }

  public static objectDeepCopy(source: any): any {
    return Helper.objectExtend(true, {}, source);
  }

  /**
   * Extend objects into another object including support for deep clone.
   * See https://gist.github.com/jonjaques/3036701
   * See https://stackoverflow.com/a/11303064
   * Examples:
   * let copy = Helper.objectExtend( {} , obj1 );
   * let merge = Helper.objectExtend( {} , obj1 , obj2 , obj3 );
   * let deep = Helper.objectExtend( true , {} , obj1 );
   * @param inputs
   */
  public static objectExtend(...inputs: any[]) {

    var options, name, src, copy, copyIsArray, clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      // skip the boolean and the target
      i = 2;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object" && !Helper.isFunction(target)) {
      target = {};
    }

    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) !== null) {
        // Extend the base object
        for (name in options) {
          src = target[name];
          copy = options[name];

          // Prevent never-ending loop
          if (target === copy) {
            continue;
          }

          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (Helper.isPlainObject(copy) || (copyIsArray = Helper.isArray2(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && Helper.isArray2(src) ? src : [];

            } else {
              clone = src && Helper.isPlainObject(src) ? src : {};
            }
            // Never move original objects, clone them
            target[name] = Helper.objectExtend(deep, clone, copy);

            // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }

    // Return the modified object
    return target;

  }



  public static sanitizeEvent(e: any): any {

    if (!e) {
      return null;
    }

    // Calculate a string representation of a node's DOM path.
    let pathToSelector = (node) => {
      if (!node || !node.outerHTML) {
        return null;
      }

      var path;
      while (node.parentElement) {
        var name = node.localName;
        if (!name) break;
        name = name.toLowerCase();
        var parent = node.parentElement;

        var domSiblings = [];

        if (parent.children && parent.children.length > 0) {
          for (var i = 0; i < parent.children.length; i++) {
            var sibling = parent.children[i];
            if (sibling.localName && sibling.localName.toLowerCase) {
              if (sibling.localName.toLowerCase() === name) {
                domSiblings.push(sibling);
              }
            }
          }
        }

        if (domSiblings.length > 1) {
          name += ':eq(' + domSiblings.indexOf(node) + ')';
        }
        path = name + (path ? '>' + path : '');
        node = parent;
      }

      return path;
    };

    // Generate a sanitized version of the event.
    let o = {
      eventName: e.toString(),
      altKey: e.altKey,
      bubbles: e.bubbles,
      button: e.button,
      buttons: e.buttons,
      cancelBubble: e.cancelBubble,
      cancelable: e.cancelable,
      clientX: e.clientX,
      clientY: e.clientY,
      composed: e.composed,
      ctrlKey: e.ctrlKey,
      currentTarget: e.currentTarget ? e.currentTarget.outerHTML : null,
      defaultPrevented: e.defaultPrevented,
      detail: e.detail,
      eventPhase: e.eventPhase,
      fromElement: e.fromElement ? e.fromElement.outerHTML : null,
      isTrusted: e.isTrusted,
      layerX: e.layerX,
      layerY: e.layerY,
      metaKey: e.metaKey,
      movementX: e.movementX,
      movementY: e.movementY,
      offsetX: e.offsetX,
      offsetY: e.offsetY,
      pageX: e.pageX,
      pageY: e.pageY,
      path: pathToSelector(e.path && e.path.length ? e.path[0] : null),
      relatedTarget: e.relatedTarget ? e.relatedTarget.outerHTML : null,
      returnValue: e.returnValue,
      screenX: e.screenX,
      screenY: e.screenY,
      shiftKey: e.shiftKey,
      sourceCapabilities: e.sourceCapabilities ? e.sourceCapabilities.toString() : null,
      target: e.target ? e.target.outerHTML : null,
      timeStamp: e.timeStamp,
      toElement: e.toElement ? e.toElement.outerHTML : null,
      type: e.type,
      view: e.view ? e.view.toString() : null,
      which: e.which,
      x: e.x,
      y: e.y
    };

    return o;

  }



  /**
  Determines if the specified item is empty.
  http://stackoverflow.com/a/4994244
  @param {any} data The data to check.
  @returns {boolean} True if data is empty.
  */
  public static isEmpty(data: any): boolean {

    // null and undefined are "empty"
    if (data === null || data === undefined) {
      return true;
    }

    if (typeof data === "number") {
      if (data) {
        return false;
      } else {
        return true;
      }
    }

    // Assume if it has a length property with a non-zero value
    // that property is correct.
    if (data.length > 0) {
      return false;
    }
    if (data.length === 0) {
      return true;
    }

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof data !== "object") {
      return true;
    }

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    //for (var key in data) {
    //    if (Object.prototype.hasOwnProperty.call(data, key)) return false;
    //}
    // If you only need to handle ECMAScript5 browsers, you can use Object.getOwnPropertyNames instead of the hasOwnProperty loop:
    try {
      if (Object.getOwnPropertyNames(data).length > 0) {
        return false;
      }
    } catch (err) {
      try {
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            return false;
          }
        }
      } catch (err) { }
    }

    return true;

  }


  /**
   * Deep copy function for TypeScript.
   * @param T Generic type of target/copied value.
   * @param target Target value to be copied.
   * @see Source project, ts-deepcopy https://github.com/ykdr2017/ts-deepcopy
   * @see Code pen https://codepen.io/erikvullings/pen/ejyBYg
   */
  public static deepCopy<T>(target: T): T {
    if (target === null) {
      return target;
    }
    if (target instanceof Date) {
      return new Date(target.getTime()) as any;
    }
    if (target instanceof Array) {
      const cp = [] as any[];
      (target as any[]).forEach((v) => { cp.push(v); });
      return cp.map((n: any) => Helper.deepCopy<any>(n)) as any;
    }
    if (typeof target === 'object' && !Helper.isEmpty(target)) {
      const cp = { ...(target as { [key: string]: any }) } as { [key: string]: any };
      Object.keys(cp).forEach(k => {
        cp[k] = Helper.deepCopy<any>(cp[k]);
      });
      return cp as T;
    }
    return target;
  };


  public static copyToClipboard(value: string) {
    const dummy = document.createElement("textarea");
    // Chrome needs it displayed to work ... dummy.style.display = 'none';
    //dummy.setAttribute("hidden", "hidden");
    document.body.appendChild(dummy);
    //dummy.setAttribute("id", "dummy_id");
    //let ele = document.getElementById("dummy_id");
    //ele.value = value;
    dummy.value = value;
    //dummy.innerHTML = value;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }


  /**
   * Parses a simple CSV string to an array of strings.
   * @param str
   * @param delimiter
   */
  public static parseCsvString(str: string, delimiter: string = ","): string[] {
    if (!str) {
      return [];
    }
    const table = Helper.parseCSV(str, delimiter);
    if (table && table.length > 0) {
      return table[0];
    }
    return [];
  }

  public static buildCsvString<T>(values: T[], delimiter: string = ",", includeDuplicateValues: boolean = true, includeEmptyValues: boolean = false): string {
    if (!values || values.length === 0) {
      return "";
    }
    let array: string[] = [];
    if (includeEmptyValues) {
      array = values.map(x => x.toString());
    } else {
      array = values.filter(x => x).map(x => x.toString());
    }
    if (!includeDuplicateValues) {
      array = Enumerable.from(array).distinct().toArray();
    }
    if (!array || array.length === 0) {
      return "";
    }
    return array.join(delimiter);
  }


  /**
  Builds array of arrays from CSV string. See
  http://stackoverflow.com/questions/1293147/javascript-code-to-parse-csv-data
  for more details.  Note that this assumes multiple rows of data and, therefor,
  returns an array of arrays so if parsing a simple CSV list get the array that
  is index 0 of the array returned.
  @param {string} str The CSV string to parse into an array.
  @returns {any[]} The array created from parsing of the specified CSV string.
  */
  public static parseCSV(str: string, delimiter: string = ","): any[] {
    var arr: any[] = [];
    var quote: boolean = false;  // true means we're inside a quoted field
    var row: number = 0;
    var col: number = 0;
    // iterate over each character, keep track of current row and column (of the returned array)
    for (var c = 0; c < str.length; c++) {
      var cc = str[c], nc = str[c + 1];        // current character, next character
      arr[row] = arr[row] || [];             // create a new row if necessary
      arr[row][col] = arr[row][col] || '';   // create a new column (start with empty string) if necessary

      // If the current character is a quotation mark, and we're inside a
      // quoted field, and the next character is also a quotation mark,
      // add a quotation mark to the current column and skip the next character
      if (cc === '"' && quote && nc === '"') { arr[row][col] += cc; ++c; continue; }

      // If it's just one quotation mark, begin/end quoted field
      if (cc === '"') { quote = !quote; continue; }

      // If it's our delimiter and we're not in a quoted field, move on to the next column
      if (cc === delimiter && !quote) { ++col; continue; }

      // If it's a newline and we're not in a quoted field, move on to the next
      // row and move to column 0 of that new row
      if (cc === '\n' && !quote) { ++row; col = 0; continue; }

      // Otherwise, append the current character to the current column
      arr[row][col] += cc;
    }
    return arr;
  }


  public static round(value, decimals) {
    return Number(Math.round(<any>(value + 'e' + decimals)) + 'e-' + decimals);
  }


  // http://blog.stevenlevithan.com/archives/javascript-roman-numeral-converter
  public static toRomanNumeral(num: number): string {
    if (!+num) {
      return "NaN";
    }
    var digits = String(+num).split("");
    var key: string[] = [
      "", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
      "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
      "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"
    ];
    var roman: string = "";
    var i: number = 3;
    while (i--) {
      roman = (key[+digits.pop() + (i * 10)] || "") + roman;
    }
    return Array(+digits.join("") + 1).join("M") + roman;
  }

  /**
  This adjusts the color luminance or brightness.
  AdjustColorLuminance("#69c", 0);		// returns "#6699cc"
  AdjustColorLuminance("6699CC", 0.2);	// "#7ab8f5" - 20% lighter
  AdjustColorLuminance("69C", -0.5);	// "#334d66" - 50% darker
  AdjustColorLuminance("000", 1);		// "#000000" - true black cannot be made lighter!
  Thanks to Craig Buckler (http://www.sitepoint.com/javascript-generate-lighter-darker-color/)
  @param {string} hex A hex color value such as “#abc” or “#123456″ (the hash is optional)
  @param {number} lum The luminosity factor, i.e. -0.1 is 10% darker, 0.2 is 20% lighter, etc.
  @returns {string} The hex color string with adjusted luminosity.
  */
  public static adjustColorLuminance(hex: string, lum: number): string {

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
      rgb += ("00" + c).substr(c.length);
    }

    return rgb;
  }

  //public static HideAllTooltips = () => {
  //  $('.tooltip').each(function (index, elem) {
  //    elem.parentElement.removeChild(elem);
  //  });
  //}

  //#endregion

  public static scrollToTop(): void {
    try {
      window.scrollTo(0, 0);
    } catch (err) { }
  }


  public static getMaxComponentHeight(topOffset: number = 200, bottomOffset: number = 100, minHeight: number = 100): number {
    return Math.max(minHeight, (window.innerHeight - (topOffset + bottomOffset)));
  }


  public static browserVersion(): string {
    const ua: string = navigator.userAgent;
    let tem: any;
    let matches = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(matches[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matches[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edge', 'Edge (legacy)').replace('Edg', 'Edge');
    }
    matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      matches.splice(1, 1, tem[1]);
    }
    return matches.join(' ');
  }

  public static isBrowserIE(): boolean {
    const browser: string = Helper.browserVersion();
    return (browser.startsWith("MSIE") || browser.startsWith("IE"));
  }

  public static isBrowserEdge(): boolean {
    const browser: string = Helper.browserVersion();
    return (browser.startsWith("Edge") && !browser.includes("legacy"));
  }

  public static isBrowserEdgeLegacy(): boolean {
    const browser: string = Helper.browserVersion();
    return browser.startsWith("Edge (legacy)");
  }

  public static isBrowserIeOrEdgeLegacy(): boolean {
    const browser: string = Helper.browserVersion();
    return (browser.startsWith("MSIE") || browser.startsWith("IE") || browser.startsWith("Edge (legacy)"));
  }

  public static isBrowserFirefox(): boolean {
    const browser: string = Helper.browserVersion();
    return browser.startsWith("Firefox");
  }

  public static isBrowserChrome(): boolean {
    const browser: string = Helper.browserVersion();
    return browser.startsWith("Chrome");
  }

  public static isBrowserSafari(): boolean {
    const browser: string = Helper.browserVersion();
    return browser.startsWith("Safari");
  }

  public static isMobilePortrait(): boolean {
    let mobile = false;
    //(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true; })(navigator.userAgent || navigator.vendor || (<any>window).opera);
    //iPhone6/7/8 Plus portrait width = 414px
    if (window.innerWidth < 415) { // <= 800) { // && window.innerHeight <= 600) {
      mobile = true;
    }
    return mobile;
  }

  public static isMobile(): boolean {
    let mobile = false;
    //(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true; })(navigator.userAgent || navigator.vendor || (<any>window).opera);
    if (window.innerWidth < 769) { // <= 800) { // && window.innerHeight <= 600) {
      mobile = true;
    }
    return mobile;
  }

  public static isTablet(): boolean {
    let tablet = false;
    //(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true; })(navigator.userAgent || navigator.vendor || (<any>window).opera);
    if (window.innerWidth >= 769 && window.innerWidth < 1024) {
      tablet = true;
    }
    return tablet;
  }

  public static isMobileOrTablet(): boolean {
    let mobileOrTablet = false;
    //(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true; })(navigator.userAgent || navigator.vendor || (<any>window).opera);
    if (window.innerWidth < 1024) {
      mobileOrTablet = true;
    }
    return mobileOrTablet;
  }

}



export class CurrencyHelper {

  public static getCurrencySymbol(isoCurencyCode: string, defaultIsoCurrencyCode: string = "USD"): string {

    if (!isoCurencyCode || isoCurencyCode === "   ") {
      isoCurencyCode = defaultIsoCurrencyCode || "";
    }

    if (isoCurencyCode === "USD") {
      return "$";
    }

    return isoCurencyCode;

  }


  public static formatCurrency(amount: number, currency: m5.CurrencyEditViewModel, detailDecimals: boolean = false) {

    if (!amount) {
      amount = 0;
    }

    if (!currency) {
      return amount.toLocaleString();
    }

    //console.log(number.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }));
    //number.toLocaleString('en', { maximumSignificantDigits: 21 })
    //{minimumFractionDigits: 2, maximumFractionDigits: 2}

    // Sort out number of decimals to use
    let decimals: number = currency.Decimals;
    if (detailDecimals) {
      decimals = currency.DetailDecimals;
    }

    // TODO DigitsInGroup ignored using this method:
    // Format with , and . as separators and then swap out as appropriate
    let formatted: string = amount.toLocaleString("en", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    if (currency.GroupSeparator !== ",") {
      formatted = Helper.replaceAll(formatted, ",", currency.GroupSeparator);
    }
    if (currency.DecimalSeparator !== ".") {
      formatted = Helper.replaceAll(formatted, ".", currency.DecimalSeparator);
    }
    // We have our negative number formatting below
    if (amount < 0) {
      formatted = Helper.replaceAll(formatted, "-", "");
    }

    if (currency.CurrencyMarker) {
      let prefix: string = "";
      let suffix: string = "";
      if (currency.CurrencyMarkerAfterAmount && currency.CurrencyMarkerSpaceSeparated) {
        suffix = ` ${currency.CurrencyMarker}`;
      } else if (currency.CurrencyMarkerAfterAmount && !currency.CurrencyMarkerSpaceSeparated) {
        suffix = currency.CurrencyMarker;
      } else if (!currency.CurrencyMarkerAfterAmount && currency.CurrencyMarkerSpaceSeparated) {
        prefix = `${currency.CurrencyMarker} `;
      } else if (!currency.CurrencyMarkerAfterAmount && !currency.CurrencyMarkerSpaceSeparated) {
        prefix = currency.CurrencyMarker;
      }
      if (amount < 0) {
        if (currency.NegativeMarkerFlag === "(") {
          if (currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `( ${prefix}`;
            suffix = `${suffix} )`;
          } else if (currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `${prefix} (`;
            suffix = `) ${suffix}`;
          } else if (!currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `(${prefix}`;
            suffix = `${suffix})`;
          } else if (!currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `${prefix}(`;
            suffix = `)${suffix}`;
          }
        } else if (currency.NegativeMarkerFlag === "+") {
          if (currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            suffix = `${suffix} -`;
          } else if (currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            suffix = `- ${suffix}`;
          } else if (!currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            suffix = `${suffix}-`;
          } else if (!currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            suffix = `-${suffix}`;
          }
        } else {
          if (currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `- ${prefix}`;
          } else if (currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `${prefix} -`;
          } else if (!currency.NegativeMarkerSpaceSeparated && currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `-${prefix}`;
          } else if (!currency.NegativeMarkerSpaceSeparated && !currency.NegativeMarkerOutsideCurrencyMarker) {
            prefix = `${prefix}-`;
          }
        }
      }
      // Apply prefix and suffix
      formatted = `${prefix}${formatted}${suffix}`;
    } else if (amount < 0) {
      if (currency.NegativeMarkerFlag === "(") {
        if (currency.NegativeMarkerSpaceSeparated) {
          formatted = `( ${formatted} )`;
        } else {
          formatted = `(${formatted})`;
        }
      } else if (currency.NegativeMarkerFlag === "+") {
        if (currency.NegativeMarkerSpaceSeparated) {
          formatted = `${formatted} -`;
        } else {
          formatted = `${formatted}-`;
        }
      } else {
        if (currency.NegativeMarkerSpaceSeparated) {
          formatted = `- ${formatted}`;
        } else {
          formatted = `-${formatted}`;
        }
      }
    }

    return formatted;

  }


}




export class Log {


  // CSS for console log styling
  protected static consoleStyleTagRed = 'color:hsl(0, 100%, 90%);background-color:hsl(0, 100%, 50%);';
  protected static consoleStyleTagOrange = 'color:hsl(39, 100%, 85%);background-color:hsl(39, 100%, 50%);';
  protected static consoleStyleTagYellow = 'color:hsl(60, 100%, 35%);background-color:hsl(60, 100%, 50%);';
  protected static consoleStyleTagGreen = 'color:hsl(120, 100%, 60%);background-color:hsl(120, 100%, 25%);';
  protected static consoleStyleTagBlue = 'color:hsl(240, 100%, 90%);background-color:hsl(240, 100%, 50%);';
  protected static consoleStyleTagPurple = 'color:hsl(300, 100%, 85%);background-color:hsl(300, 100%, 25%);';
  protected static consoleStyleTagBlack = 'color:hsl(0, 0%, 80%);background-color:hsl(0, 0%, 0%);';
  protected static consoleStyleRed = 'color:hsl(0, 100%, 50%);';
  protected static consoleStyleOrange = 'color:hsl(39, 100%, 50%);';
  protected static consoleStyleYellow = 'color:hsl(33, 100%, 32%);';
  protected static consoleStyleGreen = 'color:hsl(120, 100%, 25%);';
  protected static consoleStyleBlue = 'color:hsl(240, 100%, 50%);';
  protected static consoleStylePurple = 'color:hsl(300, 100%, 25%);';
  protected static consoleStyleBlack = 'color:hsl(0, 0%, 0%);';

  // Push messages with <span> tags into console
  protected static styledConsoleLog(message: string, type: "log" | "debug" = "log") {
    // console.log('%c Oh my heavens! ', 'background: #222; color: #bada55');
    // http://jsfiddle.net/yg6hk/5/
    var argArray = [];

    if (arguments.length) {
      var startTagRe = /<span\s+style=(['"])([^'"]*)\1\s*>/gi;
      var endTagRe = /<\/span>/gi;

      var reResultArray;
      argArray.push(arguments[0].replace(startTagRe, '%c').replace(endTagRe, '%c'));
      while (reResultArray = startTagRe.exec(arguments[0])) {
        argArray.push(reResultArray[2]);
        argArray.push('');
      }

      // pass through subsequent args since chrome dev tools does not (yet) support console.log styling of the following form: console.log('%cBlue!', 'color: blue;', '%cRed!', 'color: red;');
      for (var j = 1; j < arguments.length; j++) {
        argArray.push(arguments[j]);
      }
    }

    if (type === "debug") {
      console.debug.apply(console, argArray);
    } else {
      console.log.apply(console, argArray);
    }

  }


  /**
  This logs a warning message to the console.
  @param {any} message The message to write to the console.
  */
  public static warningMessage(message: any, ...optionalParameters: any[]): void {
    console.warn(message, ...optionalParameters);
  }

  /**
  This logs an error message to the console.
  @param {any} message The message to write to the console.
  */
  public static errorMessage(message: any, ...optionalParameters: any[]): void {
    // TODO see if message is an error object not all browsers write out objects well
    console.error(message, ...optionalParameters);
    // TODO push to error log api
  }

  /**
  This logs a debug message to the console.
  @param {string} message The message to write to the console.
  */
  public static debugMessage(message: string): void {
    Log.debug("blue", "Debug", message);
  }

  public static getStackTrace(linesToRemove: number = 1): string[] {

    let lines: string[] = [];

    // IE doesn't include a stack in the error object unless thrown
    try {
      let err = new Error();
      // Split the stack into an array of lines
      lines = err.stack.split('\n');
    } catch (e) {
      // Some browsers (looking at you IE) don't populate the stack when Error() is created but only when thrown
      // So here we catch "TypeError: Unable to get property 'split' of undefined or null reference"
      // and try to use the stack from that thrown error :)
      try {
        // Split the stack into an array of lines
        lines = e.stack.split('\n');
      } catch (e2) {
        lines.push(`Error reading stack trace: ${e2} `);
      }
    }

    if (!lines || lines.length === 0) {
      return [];
    }

    try {
      // Some browsers also output the error message at the top of the stack
      // trace so if we detect our first line isn't part of the stack then we
      // pop that error line off the top of our stack trace.
      if (!Helper.contains(lines[0], "at ", true) && !Helper.contains(lines[0], "@")) {
        lines.splice(0, 1);
      }
      // Remove lines from top of the stack trace starting at the first position
      // We default to 1 lines (this function) but callers can override this
      // if they want like Helper.getAncestorFromStackTrace() which doesn't
      // want to have it's own function in the stack either.
      if (linesToRemove) {
        if (linesToRemove >= lines.length) {
          return [];
        }
        lines.splice(0, linesToRemove);
      }
      // Trim it up
      lines = lines.map((line) => { return line.trim() });
    } catch (e3) {
      lines.push(`Error cleaning up stack trace: ${e3} `);
    }

    return lines;

  }

  /*
  Generations:
  0 = self
  1 = parent
  2 = grandparent
  */
  public static getAncestorFromStackTrace(generation: number, getFunctionNameOnly: boolean = false, functionPrefixToRemove: string = ""): string {

    let value: string = "";
    let lines: string[] = Log.getStackTrace(2);

    if (!lines || lines.length === 0) {
      return "";
    }

    if (!generation) {
      value = lines[0];
    } else if (generation > lines.length - 1) {
      value = lines[lines.length - 1];
    } else {
      value = lines[generation];
    }

    if (getFunctionNameOnly) {
      try {
        // Wrap this in try catch and save our progress back to value at each step so we give the best possible return value
        let parsed = value;
        if (Helper.contains(parsed, "(")) {
          parsed = parsed.substr(0, value.indexOf("("));
          value = parsed;
        }
        if (Helper.contains(parsed, "@")) {
          parsed = parsed.substr(0, value.indexOf("@"));
          value = parsed;
        }
        parsed = parsed.replace("at Function.", "").replace("function ", "").replace("at ", "").trim();
        value = parsed;
        if (functionPrefixToRemove && Helper.startsWith(parsed, functionPrefixToRemove, true)) {
          parsed = parsed.substr(functionPrefixToRemove.length);
          value = parsed;
        }
        value = parsed;
      } catch (err) {
        console.error(err);
      }
    }

    return value;

  }


  /**
  This logs a debug message to the console with some styling applied.
  @param {string} category The category of the message.  This impacts the styling with expected values including: url, cache, data, ui, red, orange, yellow, green, blue, purple, black.
  If the category is url the purple style is applied.
  If the category is cache the yellow style is applied.
  If the category is data the green style is applied.
  If the category is ui black style is applied.
  @param {string} title The title of the message.  In supported browsers special styling or formatting is applied to the title.
  @param {string} message The message to write to the console.
  @param {boolean} includeStackTrace When true the stack trace is included in the console output.  The default is false.
  */
  public static debug(category: string, title: string, message: string, includeStackTrace: boolean = false) {
    // Only write out debug messages in debug mode
    if (!AppConfig.debug || !message) {
      return;
    }
    if (!title || title === "") {
      title = "Debug";
    }
    if (!category || category === "") {
      category = "blue";
    }
    if (includeStackTrace) {
      // Add the stack trace to our message
      message = message + "\n" + Log.getStackTrace().join('\n');
    }
    category = category.toLowerCase();
    // The category could be a system area or a color... if it's a system area then translate that to a color
    if (category === "url") {
      category = "purple";
    } else if (category === "cache") {
      category = "yellow";
    } else if (category === "data") {
      category = "green";
    } else if (category === "ui") {
      category = "black";
    } else if (category === "debug") {
      category = "blue";
    }
    // If our category is not a recognized color then default it
    if (category !== "red" && category !== "orange" && category !== "yellow" && category !== "green" && category !== "blue" && category !== "purple" && category !== "black") {
      category = "blue";
    }
    // Translate the category to css
    let cssTitle = Log.consoleStyleTagBlue;
    let cssMessage = Log.consoleStyleBlue;
    if (category === "red") {
      cssTitle = Log.consoleStyleTagRed;
      cssMessage = Log.consoleStyleRed;
    } else if (category === "orange") {
      cssTitle = Log.consoleStyleTagOrange;
      cssMessage = Log.consoleStyleOrange;
    } else if (category === "yellow") {
      cssTitle = Log.consoleStyleTagYellow;
      cssMessage = Log.consoleStyleYellow;
    } else if (category === "green") {
      cssTitle = Log.consoleStyleTagGreen;
      cssMessage = Log.consoleStyleGreen;
    } else if (category === "blue") {
      cssTitle = Log.consoleStyleTagBlue;
      cssMessage = Log.consoleStyleBlue;
    } else if (category === "purple") {
      cssTitle = Log.consoleStyleTagPurple;
      cssMessage = Log.consoleStylePurple;
    } else if (category === "black") {
      cssTitle = Log.consoleStyleTagBlack;
      cssMessage = Log.consoleStyleBlack;
    }
    // Just do console log for browser that don't support styling in the log
    if (Helper.isBrowserIeOrEdgeLegacy()) {
      // No styling for IE or Edge Legacy
      message = "[" + title + "] " + message;
      console.log(message);
    } else if (Helper.isBrowserFirefox()) {
      // Simple styling for firefox gets rid of the quoted spaces it had in place of the span tags
      message = '<span style="' + cssMessage + '">[' + title + '] ' + message + '</span>';
      Log.styledConsoleLog(message);
    } else {
      // Chrome and Opera support our desired logging styles with styled title and message
      message = '<span style="' + cssTitle + '"> ' + title + ' </span> <span style="' + cssMessage + '">' + message + '</span>';
      Log.styledConsoleLog(message);
    }
  }

}

